function ffs(b) {
  if (typeof b !== 'number') {
    return '';
  }
  if (b >= 1000000000) {
    return (b / 1000000000).toFixed(2) + ' GB';
  }
  if (b >= 1000000) {
    return (b / 1000000).toFixed(2) + ' MB';
  }
  return (b / 1000).toFixed(2) + ' KB';
}

function fbr(bits) {
  if (typeof bits !== 'number') {
    return '';
  }
  if (bits >= 1000000000) {
    return (bits / 1000000000 / 8).toFixed(2) + ' GB/s';
  }
  if (bits >= 1000000) {
    return (bits / 1000000 / 8).toFixed(2) + ' MB/s';
  }
  if (bits >= 1000) {
    return (bits / 1000 / 8).toFixed(2) + ' KB/s';
  }
  return (bits/ 8).toFixed(2) + ' B/s';
}

function ft(seconds) {
  var date = new Date(seconds * 1000),
    days = Math.floor(seconds / 86400);
  days = days ? days + 'd ' : '';
  return (
    days +
    ('0' + date.getUTCHours()).slice(-2) +
    ':' +
    ('0' + date.getUTCMinutes()).slice(-2) +
    ':' +
    ('0' + date.getUTCSeconds()).slice(-2)
  );
}

function fp(floatValue) {
  return (floatValue * 100).toFixed(2) + ' %';
}

function rep(data) {
  return (
    fbr(data.bitrate) +
    ' | ' +
    ft(((data.total - data.loaded) * 8) / data.bitrate) +
    ' | ' +
    fp(data.loaded / data.total) +
    ' | ' +
    ffs(data.loaded) +
    ' / ' +
    ffs(data.total)
  );
}

function rp(data){
	 return ('<i class="bi-speedometer"></i> '+
    fbr(data.bitrate) + ' ' + fp(data.loaded / data.total) );
}
function gh(string) {
    var hash = 0;
    if (string.length == 0)
        return hash;
    for (let i = 0; i < string.length; i++) {
        var charCode = string.charCodeAt(i);
        hash = ((hash << 7) - hash) + charCode;
        hash = hash & hash;
    }
    return hash;
}
function cfs(size){
	if(size==0 || size > pdfwind.size * 1024 * 1024){
		return false;
	}
	return true;
}

function getFileNums(){
	return $('#file-list').children().length;
}

function testFile(file){
	var type = "([a-zA-Z0-9\s_\\.\-:])+" + pdfwind.ext;
	var fileName = file.name.toLowerCase();
	var acceptFileTypes = new RegExp(type);
	return (acceptFileTypes.test(fileName));
}

function uploadCount(){
	return $('#file-list').children().not(':not(.done)').length;
}

function showPreview(){
    if($('#preview-area').is(':hidden')){
        $('#drop-area').hide();
        $('#preview-area').css('display','inline');
    }
}

function showWaiting(){
    if($('#waiting-area').is(':hidden')){
	    $('#preview-area').hide();
	    $('#waiting-area').show();
    }
}

function showDownload(result){
    if($('#download-area').is(':hidden')){
        $('#waiting-area').hide();
        $('#download-area').show();
        if(result.compress != undefined){
            $('#downloadInfo').append('<div class="resultinfo">Saved: <span style="color:#0055FF">'+ result.compress.percent +'</span>!</div>');
            $('#downloadInfo').append('<div class="resultname">'+ result.compress.name +' <span style="color:#FF0000">'+ result.compress.oldSize + '</span> -> <span style="color:#00FF00">' + result.compress.newSize + '</span></div>');
        }
        if(result.file != undefined){
            $('#downloadAddr').attr("href", result.file);
            new QRCode(document.getElementById("qrcode"), result.file);
            var downloadLink = document.getElementById('downloadAddr');
            downloadLink.click();
        } else {
            $('#downloadAddr').attr("href", pdfwind.url + '/job/' + pdfwind.jobId);
            new QRCode(document.getElementById("qrcode"), pdfwind.url + '/job/' + pdfwind.jobId);
        }
    }
}

function addFile(data){
	var html = '<div class="col-lg-1" id="stats"><div class="spinner-border text-info mt-1" role="status" style="width: 2.5rem; height: 2.5rem;"></div></div><div class="col-lg-11" id="details"><div class="row mb-0"><span><i class="bi-file-earmark-text"></i>'+data.files[0].name+'</span></div><div class="row mb-0"><span id="speed"></span></div><div class="progress progress-slider" id="progress-div"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" id="progressbar" style="width: 0%;"></div></div></div>';
    data.context = $('<div class="row bg-light rounde shadowd" id="file">')
    				.append(html)
    				.appendTo($('#file-list'));
}

function addError(data, msg){
	data.context.find('#stats').html('<i class="i-plain i-large bi-x-circle" style="color:#e74c3c"></i>');
	data.context.find('#speed').css('color', '#e74c3c');
	data.context.find('#speed').html('<i class="bi-exclamation-triangle"></i> ' + msg);
	data.context.find('#progress-div').hide();
	$('#goBack').show();
}

function addDone(data){
	data.context.find('#stats').html('<i class="i-plain i-large bi-check-circle" style="color:#2ecc71"></i>');
	data.context.find('#progressbar').removeClass('progress-bar-striped');
	data.context.find('#progressbar').removeClass('progress-bar-animated');
	data.context.find('#progressbar').addClass('bg-success');
	data.context.addClass('done');
}

function addProgress(data){
	var progress = parseInt(data.loaded / data.total * 100, 10);
  data.context.find('#progressbar').css("width", progress + "%");
  data.context.find('#speed').html(rp(data));
}

function readPDFFile(pdf,data) {
  var pdfjsLib = window['pdfjs-dist/build/pdf'];
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
  pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
      var page = await doc.getPage(1);
      var canvas = await makeThumbScale(page, 1);
      data.context.find('#pdf-img').attr('src',canvas);
  });
}

function addMergeFile(data){
    var html = '<span class="position-absolute top-100 start-50 translate-middle badge rounded-pill bg-info" id="file-status">'+data.files[0].name+'...<span class="visually-hidden">upload status</span></span>'+
        '<span class="position-absolute top-50 start-100 translate-x2"><a href="#" class="getImage"><i class="i-rounded i-small bi-search"></i></a></span>'+
        '<span class="position-absolute top-100 start-100 translate-x2"><a href="#" class="deletePage"><i class="i-rounded i-small bi-x-square" style="background-color:#e74c3c"></i></a></span>'+
        '<div class="col pdf-bottom">'+
        '<div class="pdf-box"><img src="/images/icons/loading.gif" id="pdf-img" data-deg="0" height="180"></div>'+
        '</div>';
    data.context = $('<div class="position-relative pdf-page" id="pdf-page" data-id="'+ data.files[0].name +'">')
      .append(html)
      .appendTo($('#file-list'));
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readPDFFile(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function makeThumb(page) {
    var vp = page.getViewport({ scale: 1, });
    var canvas = document.createElement("canvas");
    var scalesize = 1.0;

    canvas.width = vp.width * scalesize;
    canvas.height = vp.height * scalesize;
    var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
    return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
        return canvas.toDataURL();
    });
}

function makeThumbScale(page, scale) {
    var vp = page.getViewport({ scale: scale, });
    var canvas = document.createElement("canvas");

    canvas.width = vp.width * scale;
    canvas.height = vp.height * scale;
    var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
    return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
        return canvas.toDataURL();
    });
}

function loadThumb(data){
  var pdfjsLib = window['pdfjs-dist/build/pdf'];
  var file_name = data.response().result.data.file_name;
  var pdf_url = pdfwind.url + '/pdf/' + pdfwind.jobId + '/' + file_name;
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
  pdfjsLib.getDocument(pdf_url).promise.then(async (doc) => {
      var page = await doc.getPage(1);
      var canvas = await makeThumbScale(page, 1);
      data.context.find('#pdf-img').attr('src',canvas);
  });
}

function loadThumbs(data){
  var pdfjsLib = window['pdfjs-dist/build/pdf'];
  var file_name = data.response().result.data.file_name;
  var pdf_url = pdfwind.url + '/pdf/' + pdfwind.jobId + '/' + file_name;
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
  pdfjsLib.getDocument(pdf_url).promise.then(async (doc) => {
    for (var i = 1; i <= doc.numPages; i++) {
      var page = await doc.getPage(i);
      var canvas = await makeThumbScale(page, 1);
      data.context.find('#pdf-img').attr('src',canvas);
    }
  });
}

function addMergeProgress(data){
    var progress = parseInt(data.loaded / data.total * 100, 10);
    data.context.find('#file-status').text(progress + "%");
}

function addMergeFileDone(data){
    data.context.attr('data-id', data.response().result.data.file_name);
    data.context.find('#file-status').text(data.files[0].name.slice(0,10) + (data.files[0].name.length > 10 ? '...' : ''));
}

function errorMessage(message){
    $('#server-error-message').attr('data-notify-type','error').attr('data-notify-msg', message);
    SEMICOLON.widget.notifications({ el: jQuery('#server-error-message') });
}

function successMessage(message){
    $('#server-error-message').attr('data-notify-type','success').attr('data-notify-msg', message);
    SEMICOLON.widget.notifications({ el: jQuery('#server-error-message') });
}

function mergeCount(){
    return $('#file-list').children().length;
}

function testPdf(data){
    if(data.type != "application/pdf"){
        return false;
    }
    return true;
}

function ftna_i18n(){
    if(!window.pdfwind){
        return 'File type is not allow!';
    }

    if(pdfwind['local'] == 'en'){
        return 'File type is not allow!';
    }
    if(pdfwind['local'] == 'ms'){
        return 'Jenis fail tidak dibenarkan!';
    }
    if(pdfwind['local'] == 'ko'){
        return '파일 형식이 허용되지 않습니다!';
    }
    if(pdfwind['local'] == 'bg'){
        return 'Типът файл не е разрешен!';
    }
    if(pdfwind['local'] == 'da'){
        return 'Filtype er ikke tilladt!';
    }
    if(pdfwind['local'] == 'de'){
        return 'Dateityp ist nicht zulässig!';
    }
    if(pdfwind['local'] == 'el'){
        return 'Ο τύπος αρχείου δεν επιτρέπεται!';
    }
    if(pdfwind['local'] == 'es'){
        return '¡El tipo de archivo no está permitido!';
    }
    if(pdfwind['local'] == 'fi'){
        return 'Tiedostotyyppi ei ole sallittu!';
    }
    if(pdfwind['local'] == 'fr'){
        return 'Le type de fichier n\'est pas autorisé !';
    }
    if(pdfwind['local'] == 'hi'){
        return 'फ़ाइल प्रकार की अनुमति नहीं है!';
    }
    if(pdfwind['local'] == 'id'){
        return 'Jenis file tidak diizinkan!';
    }
    if(pdfwind['local'] == 'it'){
        return 'Il tipo di file non è consentito!';
    }
    if(pdfwind['local'] == 'ja'){
        return 'ファイルの種類は許可されていません!';
    }
    if(pdfwind['local'] == 'nl'){
        return 'Bestandstype is niet toegestaan!';
    }
    if(pdfwind['local'] == 'pl'){
        return 'Typ pliku jest niedozwolony!';
    }
    if(pdfwind['local'] == 'pt'){
        return 'O tipo de arquivo não é permitido!';
    }
    if(pdfwind['local'] == 'ru'){
        return 'Недопустимый тип файла!';
    }
    if(pdfwind['local'] == 'sv'){
        return 'Filtyp är inte tillåten!';
    }
    if(pdfwind['local'] == 'th'){
        return 'ไม่อนุญาตประเภทไฟล์!';
    }
    if(pdfwind['local'] == 'tr'){
        return 'Dosya türüne izin verilmiyor!';
    }
    if(pdfwind['local'] == 'uk'){
        return 'Тип файлу неприпустимий!';
    }
    if(pdfwind['local'] == 'vi'){
        return 'Loại tệp không được phép!';
    }
    if(pdfwind['local'] == 'zh'){
        return '文件类型不允许！';
    }
    if(pdfwind['local'] == 'zh-Hant'){
        return '文件類型不允許！';
    }

    return 'File type is not allow!';
}

function fel_i18n(){
    if(!window.pdfwind){
        return 'File is empty or too large!';
    }

    if(pdfwind['local'] == 'en'){
        return String.format("File is empty or too large! Free user limit to {0} MB, subcribe now for process larger files!",pdfwind.size);
      }
      if(pdfwind['local'] == 'ms'){
        return String.format("Fail kosong atau terlalu besar! Had pengguna percuma kepada {0} MB, langgan sekarang untuk memproses fail yang lebih besar!",pdfwind.size);
      }
      if(pdfwind['local'] == 'ko'){
        return String.format("파일이 비어 있거나 너무 큽니다! 무료 사용자 제한은 {0}MB입니다. 더 큰 파일을 처리하려면 지금 구독하세요!",pdfwind.size);
      }
      if(pdfwind['local'] == 'bg'){
        return String.format("Файлът е празен или твърде голям! Безплатен потребителски лимит до {0} MB, абонирайте се сега за обработка на по-големи файлове!",pdfwind.size);
      }
      if(pdfwind['local'] == 'da'){
        return String.format("Filen er tom eller for stor! Gratis brugergrænse til {0} MB, abonner nu for at behandle større filer!",pdfwind.size);
      }
      if(pdfwind['local'] == 'de'){
        return String.format("Datei ist leer oder zu groß! Kostenlose Benutzerbeschränkung auf {0} MB, jetzt abonnieren, um größere Dateien zu verarbeiten!",pdfwind.size);
      }
      if(pdfwind['local'] == 'el'){
        return String.format("Το αρχείο είναι κενό ή πολύ μεγάλο! Δωρεάν όριο χρήστη στα {0} MB, εγγραφείτε τώρα για επεξεργασία μεγαλύτερων αρχείων!",pdfwind.size);
      }
      if(pdfwind['local'] == 'es'){
        return String.format("¡El archivo está vacío o es demasiado grande! Límite de usuario gratuito a {0} MB, suscríbase ahora para procesar archivos más grandes!",pdfwind.size);
      }
      if(pdfwind['local'] == 'fi'){
        return String.format("Tiedosto on tyhjä tai liian suuri! Ilmainen käyttäjäraja {0} Mt, tilaa nyt käsitelläksesi suurempia tiedostoja!",pdfwind.size);
      }
      if(pdfwind['local'] == 'fr'){
        return String.format("Le fichier est vide ou trop volumineux ! Limite d'utilisateurs gratuits à {0} Mo, abonnez-vous maintenant pour traiter des fichiers plus volumineux !",pdfwind.size);
      }
      if(pdfwind['local'] == 'hi'){
        return String.format("फ़ाइल खाली है या बहुत बड़ी है! मुफ़्त उपयोगकर्ता सीमा {0} एमबी तक, बड़ी फ़ाइलों को संसाधित करने के लिए अभी सदस्यता लें!",pdfwind.size);
      }
      if(pdfwind['local'] == 'id'){
        return String.format("File kosong atau terlalu besar! Batas pengguna gratis hingga {0} MB, berlangganan sekarang untuk memproses file yang lebih besar!",pdfwind.size);
      }
      if(pdfwind['local'] == 'it'){
        return String.format("Il file è vuoto o troppo grande! Limite utente gratuito a {0} MB, iscriviti ora per elaborare file più grandi!",pdfwind.size);
      }
      if(pdfwind['local'] == 'ja'){
        return String.format("ファイルが空か大きすぎます!無料ユーザー制限は {0} MB です。より大きなファイルを処理するには今すぐ購読してください!",pdfwind.size);
      }
      if(pdfwind['local'] == 'nl'){
        return String.format("Bestand is leeg of te groot! Gratis gebruikerslimiet tot {0} MB, schrijf u nu in voor het verwerken van grotere bestanden!",pdfwind.size);
      }
      if(pdfwind['local'] == 'pl'){
        return String.format("Plik jest pusty lub za duży! Bezpłatny limit użytkowników do {0} MB, subskrybuj teraz, aby przetwarzać większe pliki!",pdfwind.size);
      }
      if(pdfwind['local'] == 'pt'){
        return String.format("O arquivo está vazio ou muito grande! Limite de usuário gratuito para {0} MB, assine agora para processar arquivos maiores!",pdfwind.size);
      }
      if(pdfwind['local'] == 'ru'){
        return String.format("Файл пуст или слишком велик! Максимальное количество бесплатных пользователей: {0} МБ, подпишитесь сейчас, чтобы обрабатывать файлы большего размера!",pdfwind.size);
      }
      if(pdfwind['local'] == 'sv'){
        return String.format("Filen är tom eller för stor! Gratis användargräns till {0} MB, prenumerera nu för att bearbeta större filer!",pdfwind.size);
      }
      if(pdfwind['local'] == 'th'){
        return String.format("ไฟล์ว่างเปล่าหรือใหญ่เกินไป! ผู้ใช้ฟรีจำกัดไว้ที่ {0} MB สมัครสมาชิกตอนนี้เพื่อประมวลผลไฟล์ขนาดใหญ่ขึ้น!",pdfwind.size);
      }
      if(pdfwind['local'] == 'tr'){
        return String.format("Dosya boş veya çok büyük! Ücretsiz kullanıcı sınırı {0} MB, daha büyük dosyaları işlemek için şimdi abone olun!",pdfwind.size);
      }
      if(pdfwind['local'] == 'uk'){
        return String.format("Файл порожній або завеликий! Безкоштовне обмеження користувача до {0} МБ, підпишіться зараз для обробки більших файлів!",pdfwind.size);
      }
      if(pdfwind['local'] == 'vi'){
        return String.format("Tệp trống hoặc quá lớn! Giới hạn người dùng miễn phí là {0} MB, hãy đăng ký ngay để xử lý các tệp lớn hơn!",pdfwind.size);
      }
      if(pdfwind['local'] == 'zh'){
        return String.format("文件为空或太大！免费用户限制为 {0} MB，立即订阅以处理更大的文件！",pdfwind.size);
      }
      if(pdfwind['local'] == 'zh-Hant'){
        return String.format("文件為空或太大！免費用戶限制為 {0} MB，立即訂閱以處理更大的文件！",pdfwind.size);
      }

    return 'File is empty or too large!';
}

function fep_i18n(){
    if(!window.pdfwind){
        return 'Process file number exceeded!';
    }

    if(pdfwind['local'] == 'en'){
        return String.format("Free user can only process {0} files at one request, subcribe now for process more files at once.",pdfwind.count);
      }
      if(pdfwind['local'] == 'ms'){
        return String.format("Pengguna percuma hanya boleh memproses {0} fail pada satu permintaan, langgan sekarang untuk memproses lebih banyak fail sekali gus.",pdfwind.count);
      }
      if(pdfwind['local'] == 'ko'){
        return String.format("무료 사용자는 한 번의 요청으로 {0} 파일만 처리할 수 있습니다. 한 번에 더 많은 파일을 처리하려면 지금 구독하세요.",pdfwind.count);
      }
      if(pdfwind['local'] == 'bg'){
        return String.format("Безплатният потребител може да обработва само {0} файла при една заявка, абонирайте се сега за обработка на повече файлове наведнъж.",pdfwind.count);
      }
      if(pdfwind['local'] == 'da'){
        return String.format("Gratis bruger kan kun behandle {0} filer på én anmodning, abonner nu for at behandle flere filer på én gang.",pdfwind.count);
      }
      if(pdfwind['local'] == 'de'){
        return String.format("Kostenloser Benutzer kann nur {0} Dateien auf einmal verarbeiten. Melden Sie sich jetzt an, um mehr Dateien auf einmal zu verarbeiten.",pdfwind.count);
      }
      if(pdfwind['local'] == 'el'){
        return String.format("Ο δωρεάν χρήστης μπορεί να επεξεργαστεί {0} αρχεία μόνο με ένα αίτημα, εγγραφείτε τώρα για να επεξεργαστείτε περισσότερα αρχεία ταυτόχρονα.",pdfwind.count);
      }
      if(pdfwind['local'] == 'es'){
        return String.format("El usuario gratuito solo puede procesar {0} archivos en una sola solicitud, suscríbase ahora para procesar más archivos a la vez",pdfwind.count);
      }
      if(pdfwind['local'] == 'fi'){
        return String.format("Vapaa käyttäjä voi käsitellä vain {0} tiedostoa yhdellä pyynnöstä. Tilaa nyt käsitelläksesi useampia tiedostoja kerralla.",pdfwind.count);
      }
      if(pdfwind['local'] == 'fr'){
        return String.format("L'utilisateur gratuit ne peut traiter que {0} fichiers à la fois, abonnez-vous maintenant pour traiter plus de fichiers à la fois.",pdfwind.count);
      }
      if(pdfwind['local'] == 'hi'){
        return String.format("निःशुल्क उपयोगकर्ता एक अनुरोध पर केवल {0} फ़ाइलों को संसाधित कर सकता है, एक साथ अधिक फ़ाइलों को संसाधित करने के लिए अभी सदस्यता लें।",pdfwind.count);
      }
      if(pdfwind['local'] == 'id'){
        return String.format("Pengguna gratis hanya dapat memproses {0} file dengan satu permintaan, berlangganan sekarang untuk memproses lebih banyak file sekaligus.",pdfwind.count);
      }
      if(pdfwind['local'] == 'it'){
        return String.format("L'utente gratuito può elaborare solo {0} file su richiesta, iscriviti ora per elaborare più file contemporaneamente.",pdfwind.count);
      }
      if(pdfwind['local'] == 'ja'){
        return String.format("無料ユーザーは 1 回のリクエストで {0} 個のファイルのみを処理できます。一度により多くのファイルを処理するには、今すぐ登録してください。",pdfwind.count);
      }
      if(pdfwind['local'] == 'nl'){
        return String.format("Gratis gebruiker kan slechts {0} bestanden in één keer verwerken, abonneer u nu om meer bestanden tegelijk te verwerken.",pdfwind.count);
      }
      if(pdfwind['local'] == 'pl'){
        return String.format("Bezpłatny użytkownik może przetwarzać tylko {0} plików na jedno żądanie, zasubskrybuj teraz, aby przetwarzać więcej plików jednocześnie.",pdfwind.count);
      }
      if(pdfwind['local'] == 'pt'){
        return String.format("Usuário gratuito só pode processar {0} arquivos por solicitação, assine agora para processar mais arquivos de uma vez.",pdfwind.count);
      }
      if(pdfwind['local'] == 'ru'){
        return String.format("Бесплатный пользователь может обрабатывать только {0} файлов за один запрос, подпишитесь сейчас, чтобы обрабатывать больше файлов одновременно.",pdfwind.count);
      }
      if(pdfwind['local'] == 'sv'){
        return String.format("Gratis användare kan bara bearbeta {0} filer på en begäran, prenumerera nu för att bearbeta fler filer på en gång.",pdfwind.count);
      }
      if(pdfwind['local'] == 'th'){
        return String.format("ผู้ใช้ฟรีสามารถดำเนินการได้ {0} ไฟล์ต่อหนึ่งคำขอเท่านั้น สมัครสมาชิกตอนนี้เพื่อประมวลผลไฟล์เพิ่มเติมพร้อมกัน", pdfwind.count);
      }
      if(pdfwind['local'] == 'tr'){
        return String.format("Ücretsiz kullanıcı bir istekte yalnızca {0} dosyayı işleyebilir, aynı anda daha fazla dosya işlemek için şimdi abone olun.",pdfwind.count);
      }
      if(pdfwind['local'] == 'uk'){
        return String.format("Безкоштовний користувач може обробляти лише {0} файлів за один запит, підпишіться зараз, щоб обробляти більше файлів одночасно.",pdfwind.count);
      }
      if(pdfwind['local'] == 'vi'){
        return String.format("Người dùng miễn phí chỉ có thể xử lý {0} tệp theo một yêu cầu, hãy đăng ký ngay bây giờ để xử lý nhiều tệp hơn cùng một lúc.",pdfwind.count);
      }
      if(pdfwind['local'] == 'zh'){
        return String.format("免费用户一次只能处理 {0} 个文件，立即订阅以一次处理更多文件。",pdfwind.count);
      }
      if(pdfwind['local'] == 'zh-Hant'){
        return String.format("免費用戶一次只能處理 {0} 個文件，立即訂閱以一次處理更多文件。",pdfwind.count);
      }
    return 'Process file number exceeded!';
}

function error_i18n(){
    if(!window.pdfwind){
        return 'Error, please try again!';
    }
    if(pdfwind['local'] == 'en'){
        return 'Error, please try again.';
      }
      if(pdfwind['local'] == 'ms'){
        return 'Ralat, sila cuba lagi.';
      }
      if(pdfwind['local'] == 'ko'){
        return '오류입니다. 다시 시도해 주세요.';
      }
      if(pdfwind['local'] == 'bg'){
        return 'Грешка, моля опитайте отново.';
      }
      if(pdfwind['local'] == 'da'){
        return 'Fejl, prøv venligst igen.';
      }
      if(pdfwind['local'] == 'de'){
        return 'Fehler, bitte versuchen Sie es erneut.';
      }
      if(pdfwind['local'] == 'el'){
        return 'Σφάλμα, δοκιμάστε ξανά.';
      }
      if(pdfwind['local'] == 'es'){
        return 'Error, inténtalo de nuevo.';
      }
      if(pdfwind['local'] == 'fi'){
        return 'Virhe, yritä uudelleen.';
      }
      if(pdfwind['local'] == 'fr'){
        return 'Erreur, veuillez réessayer.';
      }
      if(pdfwind['local'] == 'hi'){
        return 'त्रुटि, कृपया पुनः प्रयास करें।';
      }
      if(pdfwind['local'] == 'id'){
        return 'Kesalahan, harap coba lagi.';
      }
      if(pdfwind['local'] == 'it'){
        return 'Errore, riprova.';
      }
      if(pdfwind['local'] == 'ja'){
        return 'エラー。もう一度お試しください。';
      }
      if(pdfwind['local'] == 'nl'){
        return 'Fout, probeer het opnieuw.';
      }
      if(pdfwind['local'] == 'pl'){
        return 'Błąd, spróbuj ponownie.';
      }
      if(pdfwind['local'] == 'pt'){
        return 'Erro, tente novamente.';
      }
      if(pdfwind['local'] == 'ru'){
        return 'Ошибка, попробуйте еще раз.';
      }
      if(pdfwind['local'] == 'sv'){
        return 'Fel, försök igen.';
      }
      if(pdfwind['local'] == 'th'){
        return 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
      }
      if(pdfwind['local'] == 'tr'){
        return 'Hata, lütfen tekrar deneyin.';
      }
      if(pdfwind['local'] == 'uk'){
        return 'Помилка, спробуйте ще раз.';
      }
      if(pdfwind['local'] == 'vi'){
        return 'Lỗi. Vui lòng thử lại.';
      }
      if(pdfwind['local'] == 'zh'){
        return '错误，请重试。';
      }
      if(pdfwind['local'] == 'zh-Hant'){
        return '錯誤，請重試。';
      }

    return 'Error, please try again!';
}

function imemf_i18n(){
    if(pdfwind['local'] == 'en'){
        return "Max files for merge is:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'ms'){
        return "Fail maksimum untuk cantuman ialah:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'ko'){
        return "병합할 최대 파일 수:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'bg'){
        return "„Максималните файлове за обединяване са:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'da'){
        return "Maks. filer til fletning er:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'de'){
        return "„Die maximale Anzahl an zusammenzuführenden Dateien beträgt:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'el'){
        return "Ο μέγιστος αριθμός αρχείων για συγχώνευση είναι:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'es'){
        return "El máximo de archivos para fusionar es:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'fi'){
        return "Yhdistävien tiedostojen enimmäismäärä on:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'fr'){
        return "Le nombre maximum de fichiers à fusionner est :" + pdfwind.count;
      }
      if(pdfwind['local'] == 'hi'){
        return "मर्ज के लिए अधिकतम फ़ाइलें हैं:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'id'){
        return "File maksimal untuk digabungkan adalah:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'it'){
        return "Il numero massimo di file per l\'unione è:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'ja'){
        return "「マージできる最大ファイル数は次のとおりです:」" + pdfwind.count;
      }
      if(pdfwind['local'] == 'nl'){
        return "Maximale bestanden voor samenvoegen is:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'pl'){
        return "„Maksymalna liczba plików do scalenia to:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'pt'){
        return "O máximo de arquivos para mesclagem é:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'ru'){
        return "«Максимальное количество файлов для слияния:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'sv'){
        return "Max filer för sammanfogning är:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'th'){
        return "ไฟล์สูงสุดสำหรับการรวมคือ:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'tr'){
        return "Birleştirme için maksimum dosya sayısı:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'uk'){
        return "Максимум файлів для об\'єднання:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'vi'){
        return "Tệp tối đa để hợp nhất là:" + pdfwind.count;
      }
      if(pdfwind['local'] == 'zh'){
        return "合并的最大文件数为：" + pdfwind.count;
      }
      if(pdfwind['local'] == 'zh-Hant'){
        return "合併的最大文件數為：" + pdfwind.count;
      }

    return 'Max files for merge is:' + pdfwind.count;
}

function imeaf_i18n()
{
    if(pdfwind['local'] == 'en'){
        return 'You must upload at least 2 files!';
      }
      if(pdfwind['local'] == 'ms'){
        return 'Anda mesti memuat naik sekurang-kurangnya 2 fail!';
      }
      if(pdfwind['local'] == 'ko'){
        return '최소 2개의 파일을 업로드해야 합니다!';
      }
      if(pdfwind['local'] == 'bg'){
        return 'Трябва да качите поне 2 файла!';
      }
      if(pdfwind['local'] == 'da'){
        return 'Du skal uploade mindst 2 filer!';
      }
      if(pdfwind['local'] == 'de'){
        return 'Sie müssen mindestens 2 Dateien hochladen!';
      }
      if(pdfwind['local'] == 'el'){
        return 'Πρέπει να ανεβάσετε τουλάχιστον 2 αρχεία!';
      }
      if(pdfwind['local'] == 'es'){
        return '¡Debes subir al menos 2 archivos!';
      }
      if(pdfwind['local'] == 'fi'){
        return 'Sinun on ladattava vähintään 2 tiedostoa!';
      }
      if(pdfwind['local'] == 'fr'){
        return 'Vous devez télécharger au moins 2 fichiers !';
      }
      if(pdfwind['local'] == 'hi'){
        return 'आपको कम से कम 2 फ़ाइलें अपलोड करनी होंगी!';
      }
      if(pdfwind['local'] == 'id'){
        return 'Anda harus mengunggah minimal 2 file!';
      }
      if(pdfwind['local'] == 'it'){
        return 'Devi caricare almeno 2 file!';
      }
      if(pdfwind['local'] == 'ja'){
        return '少なくとも 2 つのファイルをアップロードする必要があります。';
      }
      if(pdfwind['local'] == 'nl'){
        return 'U moet minimaal 2 bestanden uploaden!';
      }
      if(pdfwind['local'] == 'pl'){
        return 'Musisz przesłać co najmniej 2 pliki!';
      }
      if(pdfwind['local'] == 'pt'){
        return 'Você deve enviar pelo menos 2 arquivos!';
      }
      if(pdfwind['local'] == 'ru'){
        return 'Вы должны загрузить как минимум 2 файла!';
      }
      if(pdfwind['local'] == 'sv'){
        return 'Du måste ladda upp minst 2 filer!';
      }
      if(pdfwind['local'] == 'th'){
        return 'คุณต้องอัปโหลดอย่างน้อย 2 ไฟล์!';
      }
      if(pdfwind['local'] == 'tr'){
        return 'En az 2 dosya yüklemelisiniz!';
      }
      if(pdfwind['local'] == 'uk'){
        return 'Ви повинні завантажити принаймні 2 файли!';
      }
      if(pdfwind['local'] == 'vi'){
        return 'Bạn phải tải lên ít nhất 2 tập tin!';
      }
      if(pdfwind['local'] == 'zh'){
        return '您必须上传至少 2 个文件！';
      }
      if(pdfwind['local'] == 'zh-Hant'){
        return '您必須上傳至少 2 個文件！';
      }
    return 'You must upload at least 2 files!';
}

function sptmf_i18n(){
	if(pdfwind['local'] == 'en'){
	  return "Max files for split is:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'ms'){
	  return "Fail maksimum untuk pemisahan ialah:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'ko'){
	  return "분할할 최대 파일 수:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'bg'){
	  return "Максималните файлове за разделяне са:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'da'){
	  return "Maks. filer til opdeling er:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'de'){
	  return "Max. Dateien für die Aufteilung sind:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'el'){
	  return "Ο μέγιστος αριθμός αρχείων για διαχωρισμό είναι:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'es'){
	  return "El máximo de archivos para dividir es:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'fi'){
	  return "Jaetun tiedostojen enimmäismäärä on:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'fr'){
	  return "Le nombre maximum de fichiers à diviser est :" + pdfwind.count;
	}
	if(pdfwind['local'] == 'hi'){
	  return "विभाजन के लिए अधिकतम फ़ाइलें हैं:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'id'){
	  return "File maksimal untuk dipecah adalah:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'it'){
	  return "Il numero massimo di file per la suddivisione è:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'ja'){
	  return "分割できる最大ファイル数は次のとおりです:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'nl'){
	  return "Max. aantal bestanden voor splitsen is:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'pl'){
	  return "Maksymalna liczba plików do podziału to:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'pt'){
	  return "O máximo de arquivos para divisão é:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'ru'){
	  return "Максимальное количество файлов для разделения:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'sv'){
	  return "Max filer för split är:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'th'){
	  return "ไฟล์สูงสุดสำหรับการแยกคือ:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'tr'){
	  return "Bölünecek maksimum dosya sayısı:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'uk'){
	  return "Максимальна кількість файлів для розділення:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'vi'){
	  return "Tệp tối đa để phân chia là:" + pdfwind.count;
	}
	if(pdfwind['local'] == 'zh'){
	  return "分割的最大文件数为：" + pdfwind.count;
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return "分割的最大文件數為：" + pdfwind.count;
	}
	return "Max files for split is:" + pdfwind.count;
}

function sprngr_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'Range error, check your input!';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Ralat julat, semak input anda!';
	}
	if(pdfwind['local'] == 'ko'){
	  return '범위 오류입니다. 입력을 확인하세요!';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Грешка в диапазона, проверете въведеното!';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Områdefejl, tjek dit input!';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Bereichsfehler, überprüfen Sie Ihre Eingabe!';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Σφάλμα εύρους, ελέγξτε την εισαγωγή σας!';
	}
	if(pdfwind['local'] == 'es'){
	  return 'Error de rango, verifique su entrada.';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Aluevirhe, tarkista syöttämäsi!';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Erreur de plage, vérifiez votre saisie !';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'रेंज त्रुटि, अपना इनपुट जांचें!';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Kesalahan rentang, periksa masukan Anda!';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Errore di intervallo, controlla il tuo input!';
	}
	if(pdfwind['local'] == 'ja'){
	  return '範囲エラー。入力を確認してください。';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'Bereikfout, controleer uw invoer!';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Błąd zakresu, sprawdź wprowadzone dane!';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'Erro de intervalo, verifique sua entrada!';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Ошибка диапазона, проверьте ввод!';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Räckviddsfel, kontrollera din inmatning!';
	}
	if(pdfwind['local'] == 'th'){
	  return 'ข้อผิดพลาดของช่วง โปรดตรวจสอบข้อมูลที่คุณป้อน!';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Menzil hatası, girişinizi kontrol edin!';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Помилка діапазону, перевірте введені дані!';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Lỗi phạm vi, hãy kiểm tra đầu vào của bạn!';
	}
	if(pdfwind['local'] == 'zh'){
	  return '范围错误，请检查您的输入！';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '範圍錯誤，請檢查您的輸入！';
	}

	return "Range error, check your input!";
}

function spooi_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'The value is out of index!';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Nilainya di luar indeks!';
	}
	if(pdfwind['local'] == 'ko'){
	  return '값이 색인에서 벗어났습니다!';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Стойността е извън индекса!';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Værdien er uden for indekset!';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Der Wert ist außerhalb des Index!';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Η τιμή είναι εκτός ευρετηρίου!';
	}
	if(pdfwind['local'] == 'es'){
	  return '¡El valor está fuera del índice!';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Arvo on indeksin ulkopuolella!';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'La valeur est hors index !';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'मान सूचकांक से बाहर है!';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Nilainya di luar indeks!';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Il valore è fuori indice!';
	}
	if(pdfwind['local'] == 'ja'){
	  return '値がインデックス外です!';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'De waarde is buiten de index!';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Wartość jest poza indeksem!';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'O valor está fora de índice!';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Значение вне индекса!';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Värdet är utanför index!';
	}
	if(pdfwind['local'] == 'th'){
	  return 'ค่าอยู่นอกดัชนี!';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Değer indeksin dışında!';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Значення поза індексом!';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Giá trị nằm ngoài chỉ mục!';
	}
	if(pdfwind['local'] == 'zh'){
	  return '该值超出索引！';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '該值超出索引！';
	}
	return "The value is out of index!";
}

function enced_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'PDF is encrypted, please use our unlock tool to unlock it first!';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'PDF disulitkan, sila gunakan alat buka kunci kami untuk membuka kuncinya terlebih dahulu!';
	}
	if(pdfwind['local'] == 'ko'){
	  return 'PDF는 암호화되어 있습니다. 먼저 잠금 해제 도구를 사용하여 잠금을 해제하세요!';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'PDF файлът е шифрован, моля, използвайте нашия инструмент за отключване, за да го отключите първо!';
	}
	if(pdfwind['local'] == 'da'){
	  return 'PDF er krypteret, brug venligst vores oplåsningsværktøj til at låse det op først!';
	}
	if(pdfwind['local'] == 'de'){
	  return 'PDF ist verschlüsselt, bitte verwenden Sie zuerst unser Entsperr-Tool, um es zu entsperren!';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Το PDF είναι κρυπτογραφημένο, χρησιμοποιήστε το εργαλείο ξεκλειδώματος για να το ξεκλειδώσετε πρώτα!';
	}
	if(pdfwind['local'] == 'es'){
	  return 'El PDF está encriptado, ¡utilice nuestra herramienta de desbloqueo para desbloquearlo primero!';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'PDF on salattu, käytä lukituksen avaustyökaluamme avataksesi sen ensin!';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Le PDF est crypté, veuillez d\'abord utiliser notre outil de déverrouillage pour le déverrouiller !';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'पीडीएफ एन्क्रिप्टेड है, कृपया पहले इसे अनलॉक करने के लिए हमारे अनलॉक टूल का उपयोग करें!';
	}
	if(pdfwind['local'] == 'id'){
	  return 'PDF dienkripsi, harap gunakan alat buka kunci kami untuk membukanya terlebih dahulu!';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Il PDF è crittografato, utilizza prima il nostro strumento di sblocco per sbloccarlo!';
	}
	if(pdfwind['local'] == 'ja'){
	  return 'PDF は暗号化されています。まずロック解除ツールを使用してロックを解除してください。';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'PDF is gecodeerd, gebruik alstublieft onze ontgrendelingstool om het eerst te ontgrendelen!';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Plik PDF jest zaszyfrowany. Najpierw skorzystaj z naszego narzędzia odblokowującego, aby go odblokować!';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'O PDF está criptografado, use nossa ferramenta de desbloqueio para desbloqueá-lo primeiro!';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'PDF-файл зашифрован, поэтому сначала воспользуйтесь нашим инструментом разблокировки!';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'PDF är krypterad, använd vårt upplåsningsverktyg för att låsa upp det först!';
	}
	if(pdfwind['local'] == 'th'){
	  return 'PDF ได้รับการเข้ารหัส โปรดใช้เครื่องมือปลดล็อคของเราเพื่อปลดล็อคก่อน!';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'PDF şifrelenmiştir, lütfen önce kilidini açmak için kilit açma aracımızı kullanın!';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'PDF зашифровано, спершу скористайтеся нашим інструментом розблокування, щоб розблокувати його!';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'PDF được mã hóa, vui lòng sử dụng công cụ mở khóa của chúng tôi để mở khóa trước!';
	}
	if(pdfwind['local'] == 'zh'){
	  return 'PDF已加密，请先使用我们的解锁工具解锁！';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return 'PDF已加密，請先使用我們的解鎖工具解鎖！';
	}
	return "PDF is encrypted, please use our unlock tool to unlock it first!";
}

function wps_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'Wrong Password!';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Salah kata laluan!';
	}
	if(pdfwind['local'] == 'ko'){
	  return '잘못된 비밀번호!';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Грешна парола!';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Forkert kodeord!';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Falsches Passwort!';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Λάθος κωδικός!';
	}
	if(pdfwind['local'] == 'es'){
	  return '¡Contraseña incorrecta!';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Väärä salasana!';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Mauvais mot de passe!';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'गलत पासवर्ड!';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Kata sandi salah!';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Password errata!';
	}
	if(pdfwind['local'] == 'ja'){
	  return '間違ったパスワード！';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'Verkeerd wachtwoord!';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Złe hasło!';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'Senha incorreta!';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Неправильный пароль!';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Fel lösenord!';
	}
	if(pdfwind['local'] == 'th'){
	  return 'รหัสผ่านผิด!';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Yanlış şifre!';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Неправильний пароль!';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Sai mật khẩu!';
	}
	if(pdfwind['local'] == 'zh'){
	  return '密码错误！';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '密碼錯誤！';
	}

	return "Wrong Password!";
}

function dpmf_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'Max files for delete pages is:';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Fail maksimum untuk memadam halaman ialah:';
	}
	if(pdfwind['local'] == 'ko'){
	  return '삭제 페이지의 최대 파일 수는 다음과 같습니다.';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Максималният брой файлове за изтриване на страници е:';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Det maksimale antal filer til slettesider er:';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Die maximale Anzahl an Dateien zum Löschen von Seiten beträgt:';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Ο μέγιστος αριθμός αρχείων για διαγραφή σελίδων είναι:';
	}
	if(pdfwind['local'] == 'es'){
	  return 'El número máximo de archivos para eliminar páginas es:';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Poistettavien sivujen tiedostojen enimmäismäärä on:';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Le nombre maximum de fichiers pour les pages supprimées est :';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'हटाए गए पृष्ठों के लिए अधिकतम फ़ाइलें हैं:';
	}
	if(pdfwind['local'] == 'id'){
	  return 'File maks untuk menghapus halaman adalah:';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Il numero massimo di file per le pagine eliminate è:';
	}
	if(pdfwind['local'] == 'ja'){
	  return '削除ページの最大ファイル数は次のとおりです。';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'Het maximale aantal bestanden voor verwijderpagina\'s is:';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Maksymalna liczba plików do usunięcia stron to:';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'O máximo de arquivos para exclusão de páginas é:';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Максимальное количество файлов для удаления страниц:';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Max antal filer för raderade sidor är:';
	}
	if(pdfwind['local'] == 'th'){
	  return 'จำนวนไฟล์สูงสุดสำหรับการลบเพจคือ:';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Silme sayfaları için maksimum dosya sayısı:';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Максимальна кількість файлів для видалення сторінок:';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Tệp tối đa cho các trang xóa là:';
	}
	if(pdfwind['local'] == 'zh'){
	  return '删除页面的最大文件数为：';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '刪除頁面的最大文件數為：';
	}

	return 'Max files for delete pages is:';
}

function dpdl_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'You can not delete all pages!';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Anda tidak boleh memadam semua halaman!';
	}
	if(pdfwind['local'] == 'ko'){
	  return '모든 페이지를 삭제할 수는 없습니다!';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Не можете да изтриете всички страници!';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Du kan ikke slette alle sider!';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Sie können nicht alle Seiten löschen!';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Δεν μπορείτε να διαγράψετε όλες τις σελίδες!';
	}
	if(pdfwind['local'] == 'es'){
	  return '¡No puedes eliminar todas las páginas!';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Et voi poistaa kaikkia sivuja!';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Vous ne pouvez pas supprimer toutes les pages !';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'आप सभी पेज नहीं हटा सकते!';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Anda tidak dapat menghapus semua halaman!';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Non puoi eliminare tutte le pagine!';
	}
	if(pdfwind['local'] == 'ja'){
	  return 'すべてのページを削除することはできません。';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'U kunt niet alle pagina\'s verwijderen!';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Nie możesz usunąć wszystkich stron!';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'Você não pode excluir todas as páginas!';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Вы не можете удалить все страницы!';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Du kan inte ta bort alla sidor!';
	}
	if(pdfwind['local'] == 'th'){
	  return 'คุณไม่สามารถลบทุกหน้าได้!';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Tüm sayfaları silemezsiniz!';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Ви не можете видалити всі сторінки!';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Bạn không thể xóa tất cả các trang!';
	}
	if(pdfwind['local'] == 'zh'){
	  return '您无法删除所有页面！';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '您無法刪除所有頁面！';
	}
	return 'You can not delete all pages!';
}

function serr_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'Server error, please try again.';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Ralat pelayan, sila cuba lagi.';
	}
	if(pdfwind['local'] == 'ko'){
	  return '서버 오류입니다. 다시 시도해 주세요.';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Грешка в сървъра, моля опитайте отново.';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Serverfejl, prøv venligst igen.';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Serverfehler, bitte versuchen Sie es erneut.';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Σφάλμα διακομιστή, δοκιμάστε ξανά.';
	}
	if(pdfwind['local'] == 'es'){
	  return 'Error del servidor, inténtalo de nuevo.';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Palvelinvirhe, yritä uudelleen.';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Erreur de serveur, veuillez réessayer.';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'सर्वर त्रुटि, कृपया पुनः प्रयास करें।';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Kesalahan server, harap coba lagi.';
	}
	if(pdfwind['local'] == 'it'){
	  return 'Errore del server, riprova.';
	}
	if(pdfwind['local'] == 'ja'){
	  return 'サーバーエラー。もう一度お試しください。';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'Serverfout, probeer het opnieuw.';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Błąd serwera. Spróbuj ponownie.';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'Erro no servidor, tente novamente.';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Ошибка сервера, попробуйте еще раз.';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Serverfel, försök igen.';
	}
	if(pdfwind['local'] == 'th'){
	  return 'ข้อผิดพลาดของเซิร์ฟเวอร์ โปรดลองอีกครั้ง';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Sunucu hatası, lütfen tekrar deneyin.';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Помилка сервера, спробуйте ще раз.';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Lỗi máy chủ, vui lòng thử lại.';
	}
	if(pdfwind['local'] == 'zh'){
	  return '服务器错误，请重试。';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '服務器錯誤，請重試。';
	}

	return 'Server error, please try again.';
}

function que_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'In Queue.';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Dalam barisan.';
	}
	if(pdfwind['local'] == 'ko'){
	  return '대기열에 있습니다.';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'В опашка.';
	}
	if(pdfwind['local'] == 'da'){
	  return 'I kø.';
	}
	if(pdfwind['local'] == 'de'){
	  return 'In der Warteschlange.';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Στην ουρά.';
	}
	if(pdfwind['local'] == 'es'){
	  return 'En fila.';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Jonossa.';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'Dans la queue.';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'क़तार में।';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Di antrian.';
	}
	if(pdfwind['local'] == 'it'){
	  return 'In coda.';
	}
	if(pdfwind['local'] == 'ja'){
	  return '順番待ち。';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'In de wachtrij.';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'W kolejce.';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'Na fila.';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'В очереди.';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'I kö.';
	}
	if(pdfwind['local'] == 'th'){
	  return 'ในคิว.';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Sırada.';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'В черзі.';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Đợi.';
	}
	if(pdfwind['local'] == 'zh'){
	  return '在队列中。';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '在隊列中。';
	}
	return 'In Queue.';
}

function prog_i18n(){
	if(pdfwind['local'] == 'en'){
	  return 'The task is processing';
	}
	if(pdfwind['local'] == 'ms'){
	  return 'Tugas sedang diproses';
	}
	if(pdfwind['local'] == 'ko'){
	  return '작업을 처리하는 중입니다.';
	}
	if(pdfwind['local'] == 'bg'){
	  return 'Задачата се обработва';
	}
	if(pdfwind['local'] == 'da'){
	  return 'Opgaven er behandling';
	}
	if(pdfwind['local'] == 'de'){
	  return 'Die Aufgabe wird bearbeitet';
	}
	if(pdfwind['local'] == 'el'){
	  return 'Η εργασία είναι επεξεργασία';
	}
	if(pdfwind['local'] == 'es'){
	  return 'La tarea está procesando';
	}
	if(pdfwind['local'] == 'fi'){
	  return 'Tehtävä on käsittely';
	}
	if(pdfwind['local'] == 'fr'){
	  return 'La tâche est en cours de traitement';
	}
	if(pdfwind['local'] == 'hi'){
	  return 'कार्य प्रसंस्करण है';
	}
	if(pdfwind['local'] == 'id'){
	  return 'Tugas sedang diproses';
	}
	if(pdfwind['local'] == 'it'){
	  return 'L\'attività è in fase di elaborazione';
	}
	if(pdfwind['local'] == 'ja'){
	  return 'タスクは処理中です';
	}
	if(pdfwind['local'] == 'nl'){
	  return 'De taak wordt verwerkt';
	}
	if(pdfwind['local'] == 'pl'){
	  return 'Zadanie jest przetwarzane';
	}
	if(pdfwind['local'] == 'pt'){
	  return 'A tarefa é processar';
	}
	if(pdfwind['local'] == 'ru'){
	  return 'Задача — обработка';
	}
	if(pdfwind['local'] == 'sv'){
	  return 'Uppgiften är bearbetning';
	}
	if(pdfwind['local'] == 'th'){
	  return 'งานกำลังประมวลผล';
	}
	if(pdfwind['local'] == 'tr'){
	  return 'Görev işleniyor';
	}
	if(pdfwind['local'] == 'uk'){
	  return 'Завдання переробляється';
	}
	if(pdfwind['local'] == 'vi'){
	  return 'Nhiệm vụ đang xử lý';
	}
	if(pdfwind['local'] == 'zh'){
	  return '任务正在处理中';
	}
	if(pdfwind['local'] == 'zh-Hant'){
	  return '任務正在處理中';
	}
	return 'The task is processing';
}

function ftna(){
    errorMessage(ftna_i18n());
}

function ftnaa(data){
    addError(data,ftna_i18n());
}

function fel(){
    errorMessage(fel_i18n());
}

function fela(data){
    addError(data,fel_i18n());
}

function fep(){
    errorMessage(fep_i18n());
}

function fepa(data){
    addError(data,fep_i18n());
}

function xhrer(xhr){
    $('#waitStat').text(error_i18n());
}

function imemf(){
    errorMessage(imemf_i18n());
}

function imeaf()
{
    errorMessage(imeaf_i18n());
}

function sptmf(){
	errorMessage(sptmf_i18n());
}

function sprngr(){
	errorMessage(sprngr_i18n());
}

function spooi(){
	errorMessage(spooi_i18n());
}

function initMerge(){
    $('.fileupload').each(function () {
        $(this).fileupload({
            url: pdfwind.url + '/upload',
            headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
            dropZone: $(this).parent().parent().parent().find('#file-zone'),
            limitConcurrentUploads: 1,
            paramName: 'file',
            progress: function (e, data) {
                addMergeProgress(data);
            },
            done: function (e, data) {
                addMergeFileDone(data);
                $('#startMerge').show();
            },
            fail: function(e, data){
                errorMessage('Error: Upload Failed! Please try again!');
                Sentry.captureMessage('Upload Failed');
                data.context.remove();
            },
            add: function (e, data){
                if(getFileNums() > parseInt(pdfwind.count)){
                    imemf();
                } else {
                    if(cfs(data.files[0].size)){
                        if(testFile(data.files[0]) && testPdf(data.files[0])){
                            var file = data.files[0];
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                var array = new Uint8Array(e.target.result);
                                cen(array).then(function(encrypted){
                                    if(encrypted){
                                        errorMessage(enced_i18n());
                                        return false;
                                    } else {
                                        showPreview();
                                        $('#startMerge').hide();
                                        addMergeFile(data);
                                        data.process().done(function () {
                                            data.formData = window.pdfwind;
                                            data.submit();
                                        });
                                    }
                                });
                            }
                            reader.readAsArrayBuffer(file);
                        } else {
                            ftna();
                        }
                    } else {
                        fel();
                    }
                }
            },
            change: function (e, data){
            },
            stop: function (e){
                if(mergeCount()>1){
                $('#submitForm').show();
                $('#goBack').hide();
                }
            },
        });
    });

    $('#file-list').on('click', '.getImage', function(e){
        e.preventDefault();
        //onclick="event.preventDefault();showImage(this)"
        showImage(this);
    });

    //onclick="event.preventDefault();$(this).parent().parent().remove();"
    $('#file-list').on('click', '.deletePage', function(e){
        e.preventDefault();
        $(this).parent().parent().remove();
    });

	$('#startMerge').on('click', function(e){
        e.preventDefault();
        var order = $( "#file-list" ).sortable( "toArray" );

        if(order.length < 2){
            imeaf();
            return;
        }
        pdfwind['order'] = order;
        showWaiting();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}

function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function getColor(id) {
    var num = id % 2;
    if(num == 0 ){
        return 'bg-danger';
    } else {
        return 'bg-success';
    }
}

function showImage(data){
    var parent = $(data).parent().parent();
    var href = $(parent).find('#pdf-img').attr('src');
    $.magnificPopup.open({
        items:
        {
            src: '<div class="image-popup"><img src="'+href+'" class="img-fluid"></div>',
            type: 'inline',
        },
        type: 'image',
    });
}

function cut(page){
    var stats = $(page).attr('data-cut');
    if(stats == 1){
        $(page).attr('data-cut', 0);
    } else {
        $(page).attr('data-cut', 1);
    }
    var range = [];
    var file_num = 1;
    var last_cut = 1;
    var lastColor;
    $('#file-list').children().each(function () {
        $(this).find('#file-number').text('File ' + file_num);
        $(this).find('#file-number').removeClass('bg-success');
        $(this).find('#file-number').removeClass('bg-danger');
        $(this).find('#file-number').addClass(getColor(file_num));
        var curr_page = parseInt($(this).attr('data-id'));
        if($(this).attr('data-cut') == 1){
            $(this).css({'border-right-style':'dashed', 'border-right-color': '#FF0000'});
            range.push([last_cut,curr_page]);
            last_cut = curr_page + 1;
            file_num++;
        } else {
            $(this).css({'border-right-style':'', 'border-right-color': ''});
        }
    });

    if(range.length>=0){
        range.push([last_cut,$('#file-list').children().length]);
    }
}

function clearScissor(){
    $('#file-list').children().each(function () {
        $(this).find('#file-number').text('File 1');
        $(this).attr('data-cut', 0);
        $(this).find('#scissor').hide();
        $(this).find('#file-number').removeClass('bg-success');
        $(this).find('#file-number').removeClass('bg-danger');
        $(this).find('#file-number').addClass('bg-success');
        $(this).css({'border-right-style':'', 'border-right-color': ''});
    });
}

function addScissor(){
    $('#file-list').children().each(function () {
        $(this).find('#file-number').text('File 1');
        $(this).find('#scissor').show();
    });
}

function readSplitPDFFilePages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        for (var i = 1; i <= doc.numPages; i++) {
            var cut = '<span class="position-absolute top-50 start-100 translate-middle" id="scissor"><a href="#" class="splitCut"><i class="i-rounded i-small bi-scissors"></i></a></span>';
            if(doc.numPages == i){
                cut = '';
            }
            var html = '<span class="position-absolute top-100 start-50 translate-middle badge rounded-pill bg-info" id="file-page">'+ i +'<span class="visually-hidden">upload status</span></span>'+
                '<span class="position-absolute top-0 start-50 translate-middle-x badge rounded-pill bg-success" id="file-number">File 1 <span class="visually-hidden">unread messages</span></span>'+
                cut+
                '<span class="position-absolute top-100 start-100 translate-x2"><a href="#" class="getImage"><i class="i-rounded i-small bi-search"></i></a></span>'+
                '<div class="col pdf-bottom">'+
                '<div class="pdf-box"><img src="/images/icons/loading.gif" id="pdf-img" data-deg="0" height="160"></div>'+
                '</div>';
            data.context = $('<div class="position-relative pdf-page" id="pdf-page" data-id="'+ i +'" data-cut="0">')
            .append(html)
            .appendTo($('#file-list'));
        }
        for (var i = 1; i <= doc.numPages; i++) {
            var page = await doc.getPage(i);
            var canvas = await makeThumbScale(page, 1);
            renderImage(i, canvas);
            setLoadingProgress(i/doc.numPages*100);
        }
        loadingCompelte();
    });
}

function addSplitFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readSplitPDFFilePages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function addFileUpload(){
    $('#drop-area').hide();
    $('#upload-area').show();
}

function initSplit(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#upload-area').hide();
            $('#preview-area').css('display','inline');
            addSplitFile(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                sptmf();
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    addFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
        change: function (e, data){
        },
        stop: function (e){
            $('#goBack').hide();
        },
    });
    $('#split-type').change(function() {
        //reset the stat
        $('#file-list').children().each(function () {
            $(this).find('#file-number').text('File 1');
            $(this).find('#file-number').removeClass('bg-success');
            $(this).find('#file-number').removeClass('bg-danger');
            $(this).find('#file-number').addClass(getColor(1));
        });

        if(this.value == 1){
            addScissor();
        } else {
            clearScissor();
        }

        if(this.value == 2){
            $('#range').show();
            $('#pages').hide();
            $('#file-list').children().each(function () {
                $(this).find('#file-number').text('Not Select');
                $(this).find('#file-number').removeClass('bg-success');
                $(this).find('#file-number').removeClass('bg-danger');
                $(this).find('#file-number').addClass(getColor(1));
            });
        } else if(this.value == 3) {
            $('#pages').show();
            $('#range').hide();
        } else {
            $('#pages').hide();
            $('#range').hide();
            if(this.value == 4){
                var pages = $('#file-list').children().length;
                if(pages < 2)
                    return;
                $('#file-list').children().each(function () {
                    var curr_page = parseInt($(this).attr('data-id'));
                    var page = (curr_page % 2 === 0) ? 2 : 1;
                    $(this).find('#file-number').text('File ' + page);
                    $(this).find('#file-number').removeClass('bg-success');
                    $(this).find('#file-number').removeClass('bg-danger');
                    $(this).find('#file-number').addClass(getColor(page));
                });
            }

            if(this.value == 5){
                var pages = $('#file-list').children().length;
                if(pages < 2)
                    return;
                $('#file-list').children().each(function () {
                    var curr_page = parseInt($(this).attr('data-id'));
                    var page = (curr_page <= pages/2) ? 1 : 2;
                    $(this).find('#file-number').text('File ' + page);
                    $(this).find('#file-number').removeClass('bg-success');
                    $(this).find('#file-number').removeClass('bg-danger');
                    $(this).find('#file-number').addClass(getColor(page));
                });
            }
        }
    });

    $('#split-range').on('change', function() {
        if($('#split-type').val() == 2){
            $('#file-list').children().each(function () {
                $(this).find('#file-number').text('Not Select');
                $(this).find('#file-number').removeClass('bg-success');
                $(this).find('#file-number').removeClass('bg-danger');
                $(this).find('#file-number').addClass(getColor(1));
            });
            var ranges = splitByInput();
            if(ranges.length > 0){
                //console.log(ranges);
                var pages = $('#file-list').children().length;
                var count = 1;
                for(let i = 0; i < ranges.length; i++){
                    var nodes = ranges[i];
                    if(typeof nodes === 'string' && nodes.includes(' ')){
                        nodes = nodes.split(' ');
                        //console.log('nodes', nodes);
                        for(let j = 0; j < nodes.length; j++){
                            var node = nodes[j];
                            //console.log('node', node);
                            if(node.indexOf('-') > 0){
                                var pageArr = node.split('-');
                                //console.log('node is not number', pageArr, pages);
                                if(pageArr.length == 2){
                                    var from = parseInt(pageArr[0]);
                                    var to = parseInt(pageArr[1]);
                                    //console.log('from', from);
                                    //console.log('to', to);

                                    if((from) <= 0 || (to) <= 0){
                                        console.log('Page Array is out of index!lower');
                                        continue;
                                    }

                                    if((from) > pages || (to) > pages){
                                        console.log('Page Array is out of index!bigger');
                                        continue;
                                    }

                                    if(from > to){
                                        from = parseInt(pageArr[1]);
                                        to = parseInt(pageArr[0]);
                                    }

                                    for(var k = from; k <= to; k ++){
                                        var element = $('[data-id="'+ k +'"]');
                                        var hasFile = element.find('#file-number').text();
                                        //console.log('hasFile', hasFile);
                                        if(hasFile.indexOf('File') >= 0){
                                            element.find('#file-number').text(hasFile + ', ' + ( i + 1 ));
                                        } else {
                                            element.find('#file-number').text('File ' + ( i + 1 ));
                                        }
                                        element.find('#file-number').removeClass('bg-success');
                                        element.find('#file-number').removeClass('bg-danger');
                                        element.find('#file-number').addClass(getColor(i + 1));
                                    }
                                } else {
                                    console.log('Page Array is out of index!');
                                    continue;
                                }
                            } else if(parseInt(node) > 0){
                                if(parseInt(node) > pages)
                                    continue;
                                var element = $('[data-id="'+ node +'"]');
                                var hasFile = element.find('#file-number').text();
                                //console.log('node', node);
                                //console.log('hasFile', hasFile);
                                //console.log('element', element);
                                if(hasFile.indexOf('File') >= 0){
                                    element.find('#file-number').text(hasFile + ', ' + ( i + 1 ));
                                } else {
                                    element.find('#file-number').text('File ' + ( i + 1 ));
                                }
                                element.find('#file-number').removeClass('bg-success');
                                element.find('#file-number').removeClass('bg-danger');
                                element.find('#file-number').addClass(getColor(i + 1));
                            }
                            count++;
                        }
                    } else {
                        if(nodes.indexOf('-') > 0){
                            var pageArr = nodes.split('-');
                            //console.log('nodes is not number', pageArr, pages);
                            if(pageArr.length == 2){
                                var from = parseInt(pageArr[0]);
                                var to = parseInt(pageArr[1]);
                                //console.log('from', from);
                                //console.log('to', to);

                                if((from) <= 0 || (to) <= 0){
                                    console.log('Page Array is out of index!lower');
                                    continue;
                                }

                                if((from) > pages || (to) > pages){
                                    console.log('Page Array is out of index!bigger');
                                    continue;
                                }

                                if(from > to){
                                    from = parseInt(pageArr[1]);
                                    to = parseInt(pageArr[0]);
                                }

                                for(var k = from; k <= to; k ++){
                                    var element = $('[data-id="'+ k +'"]');
                                    var hasFile = element.find('#file-number').text();
                                    //console.log('hasFile', hasFile);
                                    if(hasFile.indexOf('File') >= 0){
                                        element.find('#file-number').text(hasFile + ', ' + ( i + 1 ));
                                    } else {
                                        element.find('#file-number').text('File ' + ( i + 1 ));
                                    }
                                    element.find('#file-number').removeClass('bg-success');
                                    element.find('#file-number').removeClass('bg-danger');
                                    element.find('#file-number').addClass(getColor(i + 1));
                                }
                            } else {
                                console.log('Page Array is out of index!');
                                continue;
                            }
                        } else if(parseInt(nodes) > 0){
                            if(parseInt(nodes) > pages)
                                continue;
                            var element = $('[data-id="'+ nodes +'"]');
                            var hasFile = element.find('#file-number').text();
                            //console.log('nodes', nodes);
                            //console.log('hasFile', hasFile);
                            //console.log('element', element);
                            if(hasFile.indexOf('File') >= 0){
                                element.find('#file-number').text(hasFile + ', ' + ( i + 1 ));
                            } else {
                                element.find('#file-number').text('File ' + ( i + 1 ));
                            }
                            element.find('#file-number').removeClass('bg-success');
                            element.find('#file-number').removeClass('bg-danger');
                            element.find('#file-number').addClass(getColor(i + 1));
                        }
                        count++;
                    }
                }
            }
        };
    });

    $('#split-pages').on('change', function() {
        var inputValue = $(this).val();
        if($('#split-type').val() == 3){
            if (/^[1-9]\d*$/.test(inputValue)) {
                console.log(inputValue);
                var file_num = 1;
                $('#file-list').children().each(function () {
                    $(this).find('#file-number').text('File ' + file_num);
                    $(this).find('#file-number').removeClass('bg-success');
                    $(this).find('#file-number').removeClass('bg-danger');
                    $(this).find('#file-number').addClass(getColor(file_num));
                    var curr_page = parseInt($(this).attr('data-id'));
                    if(curr_page % inputValue == 0){
                        $(this).css({'border-right-style':'dashed', 'border-right-color': '#FF0000'});
                        file_num++;
                    } else {
                        $(this).css({'border-right-style':'', 'border-right-color': ''});
                    }
                });
            } else {
                $(this).val('');
                console.log('The input value is not a positive integer');
            }
        }
    });

    $("#file-list").on("click", ".splitCut", function(event) {
        //"event.preventDefault(); cut($(this).parent().parent());"
        event.preventDefault();
        cut($(this).parent().parent());
    });

    $('#file-list').on('click', '.getImage', function(e){
        //onclick="event.preventDefault();showImage(this)"
        e.preventDefault();
        showImage(this);
    });

    $('#startSplit').on('click', function(e){
        e.preventDefault();
        var ranges = getSplitData();
        var type = getSelectType();
        if(type == 1 || type == 2){
            if(ranges.length < 1 ){
                sprngr();
                return;
            }
        } else if(type == 3){
            if(splitByEvery() == false){
                spooi();
                return;
            }
        }
        pdfwind['split'] = type;
        pdfwind['ranges'] = ranges;
        pdfwind['every'] = parseInt($('#split-pages').val());

        showWaiting();

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
            }
          },
          error: function(xhr, textStatus, error){
            $('#waitDiv').show();
            $('.errorBtn').show();
            xhrer(xhr);
          }
        });
    });
};

function getSelectType(){
    return $('#split-type').find('option:selected').val();
}

function splitBySelect(){
    var range = [];
    var file_num = 1;
    var last_cut = 1;
    $('#file-list').children().each(function () {
        var curr_page = parseInt($(this).attr('data-id'));
        if($(this).attr('data-cut') == 1){
            range.push([last_cut,curr_page]);
            last_cut = curr_page + 1;
            file_num++;
        }
    });

    if(range.length>=0){
        range.push([last_cut,$('#file-list').children().length]);
    }
    return range;
}

function checkValid(node, pages){
    var len = node.length;
    if(node.substring(0,1) == '-'){
        return false;
    }
    if(node[len -1] == '-'){
        return false;
    }

    var child = node.split(' ');
    var error = 0;
    $.each(child, function(index, value){
        if(value.indexOf('-') != -1){
            var len = value.length;
            var idx = value.indexOf('-');
            var numberA = parseInt(value.substring(0,idx));
            var numberB = parseInt(value.substring(idx+1));

            if(numberA == 0 || numberB == 0) error++;

            if(numberA > pages || numberB > pages) error++;
        } else {
            var number = parseInt(value);
            if(number == 0) error++;
            if(number > pages) error++;
        }
    });

    if(error > 0) return false;

    return true;
}
function splitByInput(){
    var range = [];
    var error = 0;
    var pages = $('#file-list').children().length;
    var range_input = $('#split-range').val();
    if(range_input.length == 0){
        return range;
    }
    var arr = range_input.split(',');
    if(arr.length == 0){
        return range;
    }
    $.each(arr, function(index, value){
        var node = $.trim(value);
        var nodeCheck = new RegExp('^(?=.*[0-9])[- 0-9]+$');
        if(nodeCheck.test(node) == false){
            range = [];
            error++;
            return [];
        }
        var subNode = node.split(' ');
        if(subNode.length == 0){
            range = [];
            error++;
            return [];
        }
        $.each(subNode, function(index, value){
            if(checkValid(value, pages) == false){
                range = [];
                error++;
                return [];
            }
        });
        if(error > 0){
            return [];
        } else {
            range.push(node);
        }
    });

    return range;
}

function splitByEvery(){
    var pages = $('#file-list').children().length;
    var every = $('#split-pages').val();
    every = parseInt(every);
    if(isNaN(every)) return false;

    if(every <= 0) return false;
    if(every >= pages - 2) return false;

    return true;
}

function getSplitData(){
    var ranges = [];
    var split_type = getSelectType();
    if(split_type == 1){
        var range_select = splitBySelect();
        $.each(range_select, function(index, value){
            var pageA = value[0];
            var pageB = value[1];
            var range = (pageA == pageB) ? pageA : pageA+ "-" + pageB;
            ranges.push(range);
        });
    } else if(split_type == 2){
        ranges = splitByInput();
    }
    return ranges;
}

function initUpload(c = false){
	$('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        progress: function (e, data) {
            addProgress(data);
        },
        done: function (e, data) {
            addDone(data);
            $('#startJob').show();
        },
        fail: function(e, data){
            addError(data,'Upload Failed! Please try again.');
            Sentry.captureMessage('Upload Failed');
        },
        add: function (e, data){
            showPreview();
            if(getFileNums() > parseInt(pdfwind.count)){
                addFile(data);
                fepa(data);
            } else {
                if(cfs(data.files[0].size)){
                    addFile(data);
                    if(testFile(data.files[0])){
                        if(c){
                            var file = data.files[0];
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                var array = new Uint8Array(e.target.result);
                                cen(array).then(function(encrypted){
                                    if(encrypted){
                                        addError(data, enced_i18n());
                                        errorMessage(enced_i18n());
                                        return false;
                                    } else {
                                        data.process().done(function () {
                                            data.formData = window.pdfwind;
                                            data.submit();
                                        });
                                    }
                                });
                            }
                            reader.readAsArrayBuffer(file);
                        } else {
                            data.process().done(function () {
                                data.formData = window.pdfwind;
                                data.submit();
                            });
                        }
                    } else {
                        ftnaa(data);
                        ftna();
                    }
                } else {
                    addFile(data);
                    fela(data);
                }
            }
        },
        change: function (e, data){
        },
        stop: function (e){
            if(uploadCount()>0){
                $('#submitForm').show();
                $('#goBack').hide();
            } else {
                $('#goBack').show();
            }
        },
    });

    $('#startResize').on('click', function(e){
        e.preventDefault();
        showWaiting();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
            if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
            }
            },
            error: function(xhr, textStatus, error){
            $('#waitDiv').show();
            xhrer(xhr);
            }
        });
    });
}

function ReadPagesForDelete(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        for (var i = 1; i <= doc.numPages; i++) {

            var html = '<span class="position-absolute top-100 start-50 translate-middle badge rounded-pill bg-info" id="file-page">'+i+'<span class="visually-hidden">upload status</span></span>'+
                '<span class="position-absolute top-50 start-100 translate-x2"><a href="#" class="getImage"><i class="i-rounded i-small bi-search"></i></a></span>'+
                '<span class="position-absolute top-100 start-100 translate-x2"><a href="#" class="deletePage"><i class="i-rounded i-small bi-x-square" style="background-color:#e74c3c"></i></a></span>'+
                '<div class="col pdf-bottom">'+
                '<div class="pdf-box"><img src="/images/icons/loading.gif" id="pdf-img" data-deg="0" height="160"></div>'+
                '</div>';
            data.context = $('<div class="position-relative pdf-page" id="pdf-page" data-id="'+ i +'" data-cut="0">')
            .append(html)
            .appendTo($('#file-list'));
            $('#file-list').scrollTop($('#file-list').height());
        }
        for (var i = 1; i <= doc.numPages; i++) {
            var page = await doc.getPage(i);
            var canvas = await makeThumbScale(page, 1);
            renderImage(i, canvas);
            setLoadingProgress(i/doc.numPages*100);
        }
        loadingCompelte();
    });
}

function addDeletePages(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        ReadPagesForDelete(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}
function initDelete(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#preview-area').css('display','inline');
            $('#upload-area').hide();
            addDeletePages(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage(dpmf_i18n() + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    sortFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
        change: function (e, data){
        },
        stop: function (e){
            $('#goBack').hide();
        },
    });

    $('#file-list').on('click', '.getImage', function(e){
        //onclick="event.preventDefault();showImage(this)"
        e.preventDefault();
        showImage(this);
    });

    $('#file-list').on('click', '.deletePage', function(e){
        //onclick="event.preventDefault();$(this).parent().parent().remove();"
        e.preventDefault();
        $(this).parent().parent().remove();
    });

    $('#startDelete').on('click', function(e){
        e.preventDefault();
        var order = $( "#file-list" ).sortable( "toArray" );

        if(order.length == 0){
            errorMessage(dpdl_i18n());
            return;
        }
        pdfwind['order'] = order;
        showWaiting();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}

function getJob(start){
  var data = {
    jobId: pdfwind.jobId,
    payload: pdfwind.payload,
  };
  $.ajax({
    url: pdfwind.url + '/getJob',
    method: 'post',
    contentType: 'application/json',
    data: JSON.stringify(data),
    success: function(result){
        if(result.code != 0){
            if(result.status == 5){
                $('#waitDiv').show();
                $('#waitStat').text(serr_i18n());
                clearInterval(start);
            }
            if(result.status == 2){
                $('#waitDiv').show();
                $('#waitStat').text(que_i18n());
            }
            if(result.status == 3){
                $('#waitDiv').show();
                if(result.num > 1 || result.progress > 1){
                    $('#waitStat').text(prog_i18n() + ': ' + result.progress + '%');
                } else {
                    $('#waitStat').text(prog_i18n() + '...');
                }
            }
        }
        else{
            clearInterval(start);
            //get download address
            //showDownload(result.jobId);
            showDownload(result);
        }
    },
    error: function(xhr, textStatus, error){
      clearInterval(start);
      $('#waitDiv').show();
      var ret = xhr.responseJSON;
      if(ret.code != undefined){
        if(ret.code == 18){
            $('#waitStat').text("Job Timeout, the file maybe too large. Please try another file.");
        } else {
            if(ret.message != undefined){
                $('#waitStat').text(ret.message);
            } else {
                $('#waitStat').text(serr_i18n());
            }
        }
      } else {
        $('#waitStat').text(serr_i18n());
      }
      $('.errorBtn').show();
    }
  });
}


function OnRegisterSubmit(form){
	$('.register-print-msg').css('display','none');
	$('.register-print-msg').html('');
	$.ajax({
		url: '/auth/register',
		method: 'post',
		data: {
			name: 		$('#registerUsername').val(),
			email: 		$('#registerEmail').val(),
			password: 	$('#registerPassword').val(),
		},
		headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
		success: function(result){
			printSuccessMsg('.register-print-msg', result.message);
			setTimeout(function(){ window.location = "/"; }, 1000);
		},
		error: function(xhr, textStatus, error){
            let result = xhr.responseJSON;
            let errors = result.message;
            printErrorMsg('.register-print-msg', errors);
		}
	});
}

function OnLoginSubmit(form){
	$('.login-print-msg').css('display','none');
	$('.login-print-msg').html('');

	$.ajax({
		url: '/auth/login',
		method: 'post',
		data: {
			email: 		$('#loginEmail').val(),
			password: 	$('#loginPassword').val(),
		},
		headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
		success: function(result){
			printSuccessMsg('.login-print-msg', result.message);
			setTimeout(function(){ window.location = "/"; }, 1000);
		},
		error: function(xhr, textStatus, error){
	    let result = xhr.responseJSON;
	    let errors = result.message;
	    printErrorMsg('.login-print-msg', errors);
		}
	});
}

function OnResetSubmit(form){
	$('.reset-print-msg').css('display','none');
	$('.reset-print-msg').html('');

	$.ajax({
		url: '/auth/forgot-password',
		method: 'post',
		data: {
			email: 		$('#Email').val(),
		},
		headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
		success: function(result){
			printSuccessMsg('.reset-print-msg', result.message);
		},
		error: function(xhr, textStatus, error){
		    let result = xhr.responseJSON;
		    let errors = result.message;
		    printErrorMsg('.reset-print-msg', errors);
		}
	});
}

function OnResetPasswordSubmit(form){
	$('.reset-password-print-msg').css('display','none');
	$('.reset-password-print-msg').html('');

	$.ajax({
		url: '/auth/reset-password',
		method: 'post',
		data: {
			token: 					$('#token').val(),
			email: 					$('#email').val(),
			password:   			$('#password').val(),
			password_confirmation:  $('#password_confirmation').val(),
		},
		headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
		success: function(result){
			printSuccessMsg('.reset-password-print-msg', result.message);
			setTimeout(function(){ window.location = "/"; }, 1000);
		},
		error: function(xhr, textStatus, error){
		    let result = xhr.responseJSON;
		    let errors = result.message;
		    printErrorMsg('.reset-password-print-msg', errors);
		}
	});
}

function OnResendEmailSubmit(form){
	$('.email-verify').css('display','none');
	$('.email-verify').html('');

	$.ajax({
		url: '/user/resend-email',
		method: 'post',
		data: {
		},
		headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
		success: function(result){
			printSuccessMsg('.email-verify', result.message);

		},
		error: function(xhr, textStatus, error){
		    let result = xhr.responseJSON;
		    let errors = result.message;
		    printErrorMsg('.email-verify', errors);
		}
	});
}

function OnChangePasswordSubmit(form){
	$('.change-password-status').css('display','none');
	$('.change-password-status').html('');

	$.ajax({
		url: '/user/change-password',
		method: 'post',
		data: {
			old_password: 			$('#old_password').val(),
			password:   			$('#password').val(),
			password_confirmation:  $('#password_confirmation').val(),
		},
		headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
		success: function(result){
			printSuccessMsg('.change-password-status', result.message);
		},
		error: function(xhr, textStatus, error){
		    let result = xhr.responseJSON;
		    let errors = result.message;
		    printErrorMsg('.change-password-status', errors);
		}
	});
}

function printErrorMsg (element,msg) {
    $(element).css('display','block');
    $(element).removeClass('alert-success');
    $(element).addClass('alert-danger');

    if(msg.constructor == Object){
    	$.each( msg, function( key, value ) {
        	$(element).append('<p class="mb-0">'+value+'</p>');
    	});
    } else {
    	$(element).append('<p class="mb-0">'+msg+'</p>');
    }
}

function printSuccessMsg(element,msg) {
	$(element).css('display','block');
    $(element).removeClass('alert-danger');
    $(element).addClass('alert-success');
    $(element).append('<p class="mb-0">'+msg+'</p>');
}


function rotateImageCW(el){
    var img = $(el).parent().parent().find('img[id="pdf-img"]');
    var Deg = img.data('deg');
    if(Deg == 360){
        Deg = 90;
    } else {
        Deg += 90;
    }
    img.data('deg', Deg);
    img.css({
        '-webkit-transform':'rotate('+Deg+'deg)',
        '-moz-transform':'rotate('+Deg+'deg)',
        'transform':'rotate('+Deg+'deg)'
    });
}

function rotateImageCCW(el){
    var img = $(el).parent().parent().find('img[id="pdf-img"]');
    var Deg = img.data('deg');
    if(Deg == 0){
        Deg = 270;
    } else {
        Deg -= 90;
    }
    img.data('deg', Deg);
    img.css({
        '-webkit-transform':'rotate('+Deg+'deg)',
        '-moz-transform':'rotate('+Deg+'deg)',
        'transform':'rotate('+Deg+'deg)'
    });
}

function loadingCompelte(){
    $('#progressBar-loading').remove();
    $('#submitForm').show();
}

function setLoadingProgress(progress){
    $('#progressBar-loading').css('width', progress + '%');
}

function renderImage(idx, canvas){
    $('#file-list').find('div[data-id='+idx+']').find('#pdf-img').attr('src',canvas);
}

function readPDFFileSortPages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        for (var i = 1; i <= doc.numPages; i++) {
            var html = '<span class="position-absolute top-100 start-50 translate-middle badge rounded-pill bg-info" id="file-page">'+i+'<span class="visually-hidden">upload status</span></span>'+
                '<span class="position-absolute top-25 start-100 translate-x2"><a href="#" class="getImage"><i class="i-rounded i-small bi-search"></i></a></span>'+
                '<span class="position-absolute top-50 start-100 translate-middle"><a href="#" class="rotateCW"><i class="i-rounded i-small bi-arrow-clockwise" style="background-color:#1E8BC3"></i></a></span>'+
                '<span class="position-absolute top-100 start-100 translate-x2"><a href="#" class="deletePage"><i class="i-rounded i-small bi-x-square" style="background-color:#e74c3c"></i></a></span>'+
                '<div class="col pdf-bottom">'+
                    '<div class="pdf-box"><img src="/images/icons/loading.gif" id="pdf-img" data-deg="0" height="150"></div>'+
                '</div>';
            data.context = $('<div class="position-relative pdf-page" id="pdf-page" data-id="'+ i +'">')
            .append(html)
            .appendTo($('#file-list'));
        }
		var completedWeight = 0;
        for (var i = 1; i <= doc.numPages; i++) {
            var page = await doc.getPage(i);
            var canvas = await makeThumbScale(page, 1);
            renderImage(i, canvas);
            setLoadingProgress(i/doc.numPages*100);
        }
        loadingCompelte();
    });
}

function addSortFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
      readPDFFileSortPages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function showUpload(){
    $('#drop-area').hide();
    $('#upload-area').show();
}

function sortFileUpload(){
    $('#drop-area').hide();
    $('#upload-area').show();
}

function initSort(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#preview-area').css('display','inline');
            $('#upload-area').hide();
            addSortFile(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage('Max files for sort is:' + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    sortFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
        change: function (e, data){
        },
        stop: function (e){
            $('#goBack').hide();
        },
    });

    $('#reverse').on('click', function(e){
        e.preventDefault();
        var el = document.getElementById('file-list');
        var sortable = new Sortable(el);
        var order = $( "#file-list" ).sortable( "toArray" );
        sortable.sort(order.reverse(), true);
    });

    $('#file-list').on('click', '.getImage', function(e){
        e.preventDefault();
        showImage(this);
    });

    //event.preventDefault(); rotateImageCW(this)
    $('#file-list').on('click', '.rotateCW', function(e){
        e.preventDefault();
        rotateImageCW(this);
    });

    //onclick="event.preventDefault();$(this).parent().parent().remove();"
    $('#file-list').on('click', '.deletePage', function(e){
        e.preventDefault();
        $(this).parent().parent().remove();
    });

    $('#startSort').on('click', function(e){
        e.preventDefault();
        var order = $( "#file-list" ).sortable( "toArray" );

        if(order.length ==0){
            errorMessage(dpdl_i18n());
            return;
        }
        getSort();
        showWaiting();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
};


function getSort(){
    var fileIds = $( '#file-list' ).sortable( 'toArray' );
    var page = [];
    var rotate = [];
     $.each(fileIds, function(index, value) {
        var deg = $('div[data-id="'+ value +'"]').find('img[id="pdf-img"]').data('deg');
        if(deg == 360) deg = 0;
        rotate.push(parseInt(deg));
        page.push(parseInt(value));
    });
    pdfwind['sort'] = page;
    pdfwind['rotate'] = rotate;
}


function readPDFFileRotatePages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        for (var i = 1; i <= doc.numPages; i++) {
            var html = '<span class="position-absolute top-100 start-50 translate-middle badge rounded-pill bg-info" id="file-page">'+i+'<span class="visually-hidden">upload status</span></span>'+
                '<span class="position-absolute top-50 start-100 translate-middle"><a href="#" class="getImage"><i class="i-rounded i-small bi-search"></i></a></span>'+
                '<span class="position-absolute top-100 start-100 translate-middle"><a href="#" class="rotateCW"><i class="i-rounded i-small bi-arrow-clockwise" style="background-color:#1E8BC3"></i></a></span>'+
                '<div class="col pdf-bottom">'+
                    '<div class="pdf-box"><img src="/images/icons/loading.gif" id="pdf-img" data-deg="0" height="150"></div>'+
                '</div>';
            data.context = $('<div class="position-relative pdf-page" id="pdf-page" data-id="'+ i +'">')
            .append(html)
            .appendTo($('#file-list'));
        }
        var completedWeight = 0;
        for (var i = 1; i <= doc.numPages; i++) {
            var page = await doc.getPage(i);
            var canvas = await makeThumbScale(page, 1);
            renderImage(i, canvas);
            setLoadingProgress(i/doc.numPages*100);
        }
        loadingCompelte();
        $('#rotateAll').show();
    });
}

function addRotateFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readPDFFileRotatePages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function initRotate(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#preview-area').css('display','inline');
            $('#upload-area').hide();
            addRotateFile(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage('Max files for rotate is:' + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    sortFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
        change: function (e, data){
        },
        stop: function (e){
            $('#goBack').hide();
        },
    });

    $('#rotateAll').on('click', function(e){
        e.preventDefault();
        var imgs = $( "#file-list" ).children().find('img[id="pdf-img"]');
        $.each(imgs, function(index, value) {
            rotateImageCW(value);
        });
    });

    $('#file-list').on('click', '.rotateCW', function(e){
        e.preventDefault();
        rotateImageCW(this);
    });

    $('#file-list').on('click', '.getImage', function(e){
        e.preventDefault();
        showImage(this);
    });

    $('#startRotate').on('click', function(e){
        e.preventDefault();
        var order = $( "#file-list" ).sortable( "toArray" );

        if(order.length ==0){
            errorMessage(dpdl_i18n());
            return;
        }
        getRotate();
        showWaiting();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
};


function getRotate(){
    var fileIds = $( '#file-list' ).sortable( 'toArray' );
    var page = [];
    var rotate = [];
    $.each(fileIds, function(index, value) {
        var deg = $('div[data-id="'+ value +'"]').find('img[id="pdf-img"]').data('deg');
        if(deg == 360) deg = 0;
        rotate.push(parseInt(deg));
        page.push(parseInt(value));
    });
    pdfwind['sort'] = page;
    pdfwind['rotate'] = rotate;
}

function readPDFFileExtractPages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        for (var i = 1; i <= doc.numPages; i++) {
            var html = '<span class="position-absolute top-100 start-50 translate-middle badge rounded-pill bg-info" id="file-page">'+i+'<span class="visually-hidden">upload status</span></span>'+
                '<span class="position-absolute top-100 start-100 translate-middle"><a href="#" class="getImage"><i class="i-rounded i-small bi-search"></i></a></span>'+
                '<div class="col pdf-bottom">'+
                    '<div class="pdf-box"><img src="/images/icons/loading.gif" id="pdf-img" data-deg="0" height="150"></div>'+
                '</div>';
            data.context = $('<div class="position-relative pdf-page" id="pdf-page" data-id="'+ i +'">')
            .append(html)
            .appendTo($('#file-list'));
        }
        var completedWeight = 0;
        for (var i = 1; i <= doc.numPages; i++) {
            var page = await doc.getPage(i);
            var canvas = await makeThumbScale(page, 1);
            renderImage(i, canvas);
            setLoadingProgress(i/doc.numPages*100);
        }
        loadingCompelte();
    });
}

function pageSelect(e){
    var box = $(e).find('.pdf-box');
    if(box.hasClass('pdf-selected')){
        box.removeClass('pdf-selected');
    } else {
        box.addClass('pdf-selected');
    }
}

function addExtractPages(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readPDFFileExtractPages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function initExtractPages(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#preview-area').css('display','inline');
            $('#upload-area').hide();
            addExtractPages(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage('Max files for extract pages is: ' + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    sortFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
        change: function (e, data){
        },
        stop: function (e){
            $('#goBack').hide();
        },
    });

    $('#file-list').on('click', '.getImage', function(e){
        //onclick="event.preventDefault();showImage(this)"
        e.preventDefault();
        showImage(this);
    });

    //onclick="pageSelect(this)"
    $('#file-list').on('click', '.pdf-page', function(e){
        e.preventDefault();
        pageSelect(this);
    });

    $('#startExtract').on('click', function(e){
        e.preventDefault();
        var pages = [];
        $('#file-list').children().each(function(){
            var page = $(this).data('id');
            var box = $(this).find('.pdf-box');
            if(box.hasClass('pdf-selected')){
                pages.push(page);
            }
        });

        if(pages.length < 1){
            errorMessage('You must select at least 1 page!');
            return;
        }

        pdfwind['pages'] = pages;
        showWaiting();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}
var cropArea = null;
function readCropPdf(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        var page = await doc.getPage(1);
        var canvas = await makeThumbScale(page, 1);
        var vp = page.getViewport({ scale: 1, });
        var html =
            '<img src="'+canvas+'" id="pdf-img">';
            data.context = $('<div class="position-relative" style="height: 100%;" id="pdf-page" data-id="1" data-cut="0">')
            .append(html)
            .appendTo($('#file-list'));

            cropArea = new Croppr('#pdf-img', {});

        $(".page-range").ionRangeSlider({
            type: "double",
            min: 1,
            max: doc.numPages,
            from: 0,
            to: doc.numPages,
            prefix: "Page: ",
            values_separator: " to "
        });

    });
}

function addCropPDFFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readCropPdf(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function cropPDFUpload(){
    $('.fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#upload-area').hide();
            $('#preview-area').css('display','inline');
            addCropPDFFile(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage('Max files for Crop PDF is:' + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    addFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
    });
}

function initCropPDF(){
    console.log('initCropPDF jobId: ' + pdfwind.jobId);
    cropPDFUpload();
    $('#cropPDF').on('click', function(e){
        e.preventDefault();
        var options = $("#crop-action").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });
        var cropData = cropArea.getValue();
        pdfwind['crop-x'] = cropData.x;
        pdfwind['crop-y'] = cropData.y;
        pdfwind['crop-w'] = cropData.width;
        pdfwind['crop-h'] = cropData.height;
        showWaiting();

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });

    console.log('CropPDF component inited.');
}

var imageCavas;
var watermarkImage;
var watermarkWidth;
var watermarkImageAspectRatio;
function readWaterMarkFilePages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        var page = await doc.getPage(1);
        var canvas = await makeThumbScale(page, 1);
        imageCavas = canvas;
        var vp = page.getViewport({ scale: 1, });
        var html =
            '<div style="height: 100%;"><img src="'+canvas+'" id="pdf-img" style="min-height: '+vp.height+'px; min-width: '+vp.width+'px;"><canvas id="canvas"></canvas></div>';
            data.context = $('<div class="position-relative" style="height: 100%;" id="pdf-page" data-id="1" data-cut="0">')
            .append(html)
            .appendTo($('#file-list'));


        $(".page-range").ionRangeSlider({
            type: "double",
            min: 1,
            max: doc.numPages,
            from: 0,
            to: doc.numPages,
            prefix: "Page: ",
            values_separator: " to "
        });

        $(".image-page-range").ionRangeSlider({
            type: "double",
            min: 1,
            max: doc.numPages,
            from: 0,
            to: doc.numPages,
            prefix: "Page: ",
            values_separator: " to "
        });
    });
}

function addWaterMarkFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readWaterMarkFilePages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

const getAspectRatio = (width, height) => {
    return width / height;
};

const getWidthFromRatio = (height, aspectRatio) => {
    return height * aspectRatio;
};

const getHeightFromRatio = (width, aspectRatio) => {
    return width / aspectRatio;
};

const changeImageWidth = (image, width, aspectRatio, maintainAspectRatio) => {
    if (maintainAspectRatio) {
        const newHeight = getHeightFromRatio(width, aspectRatio);
        image.width = width;
        image.height = newHeight;
    } else {
        image.width = width;
    }
};

const changeImageHeight = (image, height, aspectRatio, maintainAspectRatio) => {
    if (maintainAspectRatio) {
        const newWidth = getWidthFromRatio(height, aspectRatio);
        image.width = newWidth;
        image.height = height;
    } else {
        image.height = height;
    }
};

const getImage = (e, callback) => {
    const files = e.files[0];

    if (files) {
        const image = files;
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                callback(img);
            };
        };
    }
};

function pdfuploaded(){
    return pdfwind['inited'] == true;
}

function watermarkUploadError(){
    $('#imageWatermark').hide();
    $('#goBack').show();
}

function watermarkUploadSuccess(){
    $('#imageWatermark').show();
}

function waterMarkUpload(){
    $('.fileupload').each(function () {
        $(this).fileupload({
            url: pdfwind.url + '/upload',
            headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
            dropZone: $('#file-zone'),
            limitConcurrentUploads: 1,
            paramName: 'file',
            singleFileUploads: false,
            dataType: 'json',
            progress: function (e, data) {
                if(pdfuploaded()){
                    setLoadingProgress(data.loaded / data.total*100);
                } else {
                    $('#infoStat').html(rp(data));
                }
            },
            done: function (e, data) {
                if(pdfuploaded()){
                    getImage(data, (img) => {
                        watermarkImage = img;
                        watermarkWidth = img.width;
                        watermarkImageAspectRatio = getAspectRatio(img.width, img.height);
                        DrawImageWaterMark();
                        watermarkUploadSuccess();
                        pdfwind['imageInited'] = true;
                        $('#progressBar-loading').remove();
                    });
                } else {
                    $('#upload-area').hide();
                    $('#preview-area').css('display','inline');
                    pdfwind['inited'] = true;
                    addWaterMarkFile(data);
                }
            },
            fail: function(e, data){
                if(pdfuploaded()){
                    errorMessage('Upload Failed!, please refresh page and start a new task.');
                    Sentry.captureMessage('Upload Failed');
                    watermarkUploadError();
                } else {
                    errorMessage('Error: Upload Failed! Please try again!');
                    Sentry.captureMessage('Upload Failed');
                    $('#uploadError').show();
                    $('#infoMsg').text('Error: Upload Failed! Please try again!');
                }
            },
            add: function (e, data){
                if(pdfuploaded()){
                    if(data.files.length > parseInt(pdfwind.count)){
                        errorMessage('Max files for add watermark is:' + pdfwind.count);
                    } else {
                        if(cfs(data.files[0].size)){
                            if(testFile(data.files[0])){
                                data.process().done(function () {
                                    data.formData = window.pdfwind;
                                    data.submit();
                                });
                            } else {
                                ftna();
                            }
                        } else {
                            fel();
                        }
                    }
                } else {
                    if(data.files.length > parseInt(pdfwind.count)){
                        errorMessage('Max files for add watermark is:' + pdfwind.count);
                    } else {
                        if(cfs(data.files[0].size)){
                            if(testFile(data.files[0]) && testPdf(data.files[0])){
                                var file = data.files[0];
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    var array = new Uint8Array(e.target.result);
                                    cen(array).then(function(encrypted){
                                        if(encrypted){
                                            errorMessage(enced_i18n());
                                            return false;
                                        } else {
                                            addFileUpload();
                                            data.process().done(function () {
                                                data.formData = window.pdfwind;
                                                data.submit();
                                            });
                                        }
                                    });
                                }
                                reader.readAsArrayBuffer(file);
                            } else {
                                ftna();
                            }
                        } else {
                            fel();
                        }
                    }
                }
            },
            error: function (e, data){
                if(pdfuploaded()){
                    errorMessage('Error:'+ data + ', please try again.');
                    watermarkUploadError();
                } else {
                    errorMessage('Error:'+ data);
                    $('#uploadError').show();
                    $('#infoMsg').text('Error:'+ data);
                }
            },
        });
    });
}

function initWaterMark(){
    console.log('initWaterMark jobId: ' + pdfwind.jobId);
    waterMarkUpload();
    $(".font-size").ionRangeSlider({
        min: 10,
        max: 100,
        from: 15,
        onChange: function (data) {
            DrawTextWaterMark();
        },
    });

    $(".text-opacity").ionRangeSlider({
        type: "single",
        min: 0.00,
        max: 1.00,
        from: 1.00,
        step: 0.01,
        onChange: function (data) {
            DrawTextWaterMark();
        },
    });

    $(".text-rotate").ionRangeSlider({
        min: -180,
        max: 180,
        from: 0,
        onChange: function (data) {
            DrawTextWaterMark();
        },
    });

    $(".x-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "X Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawTextWaterMark();
        },
    });

    $(".y-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "Y Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawTextWaterMark();
        },
    });

    $('#color-picker').spectrum({
        type: "component",
        preferredFormat: "hex",
        showPalette: true,
        showAlpha: false,
        showInput: true,
        move: function(color) {
            DrawTextWaterMark();
        },
    });

    $(".image-scale").ionRangeSlider({
        min: 0.1,
        max: 10,
        from: 1,
        step: 0.01,
        onChange: function (data) {
            DrawImageWaterMark();
        },
    });

    $(".image-opacity").ionRangeSlider({
        type: "single",
        min: 0.0,
        max: 1.0,
        from: 1.0,
        step: 0.1,
        onChange: function (data) {
            DrawImageWaterMark();
        },
    });

    $(".image-rotate").ionRangeSlider({
        min: -180,
        max: 180,
        from: 0,
        onChange: function (data) {
            DrawImageWaterMark();
        },
    });

    $(".image-x-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "X Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawImageWaterMark();
        },
    });

    $(".image-y-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "Y Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawImageWaterMark();
        },
    });

    $(window).resize(function() {
        if($('#preview-area').is(':visible')){
            DrawTextWaterMark();
        }
    });

    $('#watermark-font').on('change', function(){
        DrawTextWaterMark();
    });

    $('#draw-type').on('change', function(){
        if($(this).val() == 2){
            $('input[type="radio"]').prop('disabled', true);
        } else {
            $('input[type="radio"]').prop('disabled', false);
        }
        DrawTextWaterMark();
    });

    $('#watermark-text').on('input', function(){
        DrawTextWaterMark();
    });

    $('input[name="position"]').on('change', function(){
        DrawTextWaterMark();
    });

    $('#text-italic').on('change', function(){
        DrawTextWaterMark();
    });

    $('#text-bold').on('change', function(){
        DrawTextWaterMark();
    });

    $('input[name="image-position"]').on('change', function(){
        DrawImageWaterMark();
    });

    $('#image-draw-type').on('change', function(){
        if($(this).val() == 2){
            $('input[type="radio"]').prop('disabled', true);
        } else {
            $('input[type="radio"]').prop('disabled', false);
        }
        DrawImageWaterMark();
    });

    var myTab = document.getElementById('watermark-type');
    if(myTab != undefined){
        var tabInstance = new bootstrap.Tab(myTab);

        myTab.addEventListener('click', function (event) {
            event.preventDefault()
            if (event.target.classList.contains('nav-link')) {
                var canvas = document.getElementById('canvas');
                var ctx = canvas.getContext('2d');
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.restore();

                var target = event.target.getAttribute('id')
                if(target === 'text-watermark-tab'){
                    DrawTextWaterMark();
                } else {
                    DrawImageWaterMark();
                }
            }
        });
    }

    $('#textWatermark').on('click', function(e){
        e.preventDefault();
        var options = $("#text-watermark-action").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        if(pdfwind['color-picker'].length == 0){
            errorMessage('Please select color');
            return false;
        }

        if(pdfwind['watermark-text'].length == 0){
            errorMessage('Please enter text');
            return false;
        }

        const colorRegxp = /^#([0-9a-f]{3}){1,2}$/i;
        if(!colorRegxp.test(pdfwind['color-picker'])){
            errorMessage('Invalid color');
            return false;
        }

        if(pdfwind['watermark-text'].length > 100){
            errorMessage('Text is too long');
            return false;
        }

        showWaiting();

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });


    $('#imageWatermark').on('click', function(e){
        e.preventDefault();
        var options = $("#image-watermark-action").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        if(pdfwind['imageInited'] == false || pdfwind['imageInited'] == undefined){
            errorMessage('Please upload image');
            return false;
        }
        showWaiting();
        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });

    console.log('WaterMark component inited.');
}

function DrawTextWaterMark(){
    var text = $('#watermark-text').val();
    if(text.length<1){
        return;
    }
    var canvas = document.getElementById('canvas');
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var img = document.getElementById('pdf-img');
    var drawFont = $('#watermark-font option:selected').text();
    var fontSize = $('.font-size').val();
    var isItalic = $('#text-italic').prop('checked');
    var isBold = $('#text-bold').prop('checked');
    var fontOpcity = $('.text-opacity').val();
    var fontRotate = $('.text-rotate').val() * Math.PI / 180;
    var fontXOffset = $('.x-offset').val();
    var fontYOffset = $('.y-offset').val();
    var fontColor = $('#color-picker').spectrum('get').toRgbString();
    var color = fontColor.replace(')', ', ' + fontOpcity + ')').replace('rgb', 'rgba');
    var drawType = $('#draw-type option:selected').val();
    var position = $('input[name="position"]:checked').val();
    canvas.style.position = "absolute";
    canvas.width = img.offsetWidth;
    canvas.height = img.offsetHeight;
    canvas.style.top = img.offsetTop + 'px';
    canvas.style.left = img.offsetLeft + 'px';
    canvas.style.zIndex = '1';
    var italic = isItalic ? 'italic ' : '';
    var bold = isBold ? 'bold ' : '';

    ctx.font = italic + bold + fontSize + 'px ' + drawFont;
    var metrics = ctx.measureText(text);
    var textWidth = parseInt(metrics.width);
    var fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
    var actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
    var textHeight = 0;

    if(drawType == 1){
        var positions = {
            1: { posx: 10 + (textWidth / 2), posy: 10 + parseInt(actualHeight) / 2 },
            2: { posx: canvas.width / 2, posy: 10 + parseInt(actualHeight) / 2 },
            3: { posx: canvas.width - (textWidth / 2), posy: 10 + parseInt(actualHeight) / 2 },
            4: { posx: 10 + (textWidth / 2), posy: canvas.height / 2 + parseInt(actualHeight) / 2 },
            5: { posx: canvas.width / 2, posy: canvas.height / 2 + parseInt(actualHeight) / 2 },
            6: { posx: canvas.width - (textWidth / 2), posy: canvas.height / 2 + parseInt(actualHeight) / 2 },
            7: { posx: 10 + (textWidth / 2), posy: canvas.height - parseInt(actualHeight) / 2 - 10 },
            8: { posx: canvas.width / 2, posy: canvas.height - parseInt(actualHeight) / 2 - 10 },
            9: { posx: canvas.width - (textWidth / 2), posy: canvas.height - parseInt(actualHeight) / 2 - 10 }
        };

        var pos = positions[position];
        var posx = pos.posx;
        var posy = pos.posy;
        posx += parseInt(fontXOffset);
        posy += parseInt(fontYOffset);
        ctx.fillStyle = color;
        ctx.textAlign = 'center';
        ctx.translate(posx, posy);
        ctx.rotate(fontRotate);
        ctx.fillText(text, 0, 0);
    } else {
        for (var i = 0; i < 15; i += 1) {
            var posx = 0;
            var posy = 0;
            var xIndex = i % 3;
            var yIndex = Math.floor(i / 3);
            if (xIndex == 0) {
                posx = 10 + (textWidth / 2);
            } else if (xIndex == 1) {
                posx = canvas.width / 2;
            } else if (xIndex == 2) {
                posx = canvas.width - (textWidth / 2);
            }
            if (yIndex == 0) {
                posy = 10 + textHeight + parseInt(actualHeight) / 2;
            } else if (yIndex == 1) {
                posy = canvas.height / 2 - (canvas.height / 2) / 2;
            } else if (yIndex == 2) {
                posy = canvas.height / 2;
            } else if (yIndex == 3) {
                posy = canvas.height / 2 + (canvas.height / 2) / 2;
            } else if (yIndex == 4) {
                posy = canvas.height - parseInt(actualHeight) / 2 - 10;
            }
            posx += parseInt(fontXOffset);
            posy += parseInt(fontYOffset);
            ctx.save();
            ctx.font = italic + bold + fontSize + 'px ' + drawFont;
            ctx.fillStyle = color;
            ctx.textAlign = 'center';
            ctx.translate(posx, posy);
            ctx.rotate(fontRotate);
            ctx.fillText(text, 0, 0);
            ctx.restore();
        }
    }
}

function DrawImageWaterMark(){
    if(watermarkImage == null){
        return;
    }
    var canvas = document.getElementById('canvas');
    var ctx = canvas.getContext('2d');
    var img = document.getElementById('pdf-img');
    var Scale = ($('.image-scale').val());
    var Opcity = ($('.image-opacity').val());
    var Rotate = parseInt($('.image-rotate').val()) * Math.PI / 180;
    var OffsetX = parseInt($('.image-x-offset').val());
    var OffsetY = parseInt($('.image-y-offset').val());
    var position = $('input[name="image-position"]:checked').val();
    var drawType = $('#image-draw-type option:selected').val();

    var Width = watermarkWidth * Scale;
    changeImageWidth(watermarkImage, Width, watermarkImageAspectRatio, true);

    canvas.style.position = "absolute";
    canvas.width = img.offsetWidth;
    canvas.height = img.offsetHeight;
    canvas.style.top = img.offsetTop + 'px';
    canvas.style.left = img.offsetLeft + 'px';
    canvas.style.zIndex = '1';

    if(drawType == 1){
        var positions = {
            1: { posx: 10 + (watermarkImage.width / 2), posy: 10 + (watermarkImage.height / 2) },
            2: { posx: canvas.width / 2, posy: 10 + (watermarkImage.height / 2) },
            3: { posx: canvas.width - (watermarkImage.width / 2) - 10, posy: 10 + (watermarkImage.height / 2) },
            4: { posx: 10 + (watermarkImage.width / 2), posy: canvas.height / 2 },
            5: { posx: canvas.width / 2, posy: canvas.height / 2 },
            6: { posx: canvas.width - (watermarkImage.width / 2) - 10, posy: canvas.height / 2 },
            7: { posx: 10 + (watermarkImage.width / 2), posy: canvas.height - (watermarkImage.height / 2) - 10 },
            8: { posx: canvas.width / 2, posy: canvas.height - (watermarkImage.height / 2) - 10 },
            9: { posx: canvas.width - (watermarkImage.width / 2) - 10, posy: canvas.height - (watermarkImage.height / 2) - 10 }
        };

        var pos = positions[position];
        var posx = pos.posx;
        var posy = pos.posy;

        posx += OffsetX;
        posy += OffsetY;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        var ie = new Image();
        ie.src = watermarkImage.src;
        ie.onload = function() {
            function drawImage() {
                ctx.save();
                ctx.translate(posx, posy);
                ctx.rotate(Rotate);
                ctx.globalAlpha = Opcity;
                ctx.drawImage(
                ie,
                -watermarkImage.width / 2,
                -watermarkImage.height / 2,
                watermarkImage.width,
                watermarkImage.height
                );
                ctx.restore();
            }
            drawImage();
        };
        ctx.globalAlpha = 1;
    } else {
        var posx = 0;
        var posy = 0;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var ie = new Image();
        ie.src = watermarkImage.src;
        ie.onload = function()
        {
            for(var i=0; i<3; i+=1){
                for(var j=0; j<5; j+=1){
                    if(i == 0){
                        posx = 10 + (watermarkImage.width/2);
                    } else if(i == 1){
                        posx = canvas.width/2;
                    } else if(i == 2){
                        posx = canvas.width - (watermarkImage.width/2) - 10;
                    }

                    if(j == 0){
                        posy = 10 + (watermarkImage.height/2);
                    } else if(j == 1){
                        posy = canvas.height/2 - (canvas.height/2) / 2;
                    } else if(j == 2){
                        posy = canvas.height/2;
                    } else if(j == 3){
                        posy = canvas.height/2 + (canvas.height/2) / 2;
                    } else if(j == 4){
                        posy = canvas.height - (watermarkImage.height/2) - 10;
                    }

                    posx += (OffsetX);
                    posy += (OffsetY);
                    function drawImage(){
                        ctx.save();
                        ctx.translate(posx, posy);
                        ctx.rotate(Rotate);
                        ctx.globalAlpha = Opcity;
                        ctx.drawImage(
                            ie,
                            -watermarkImage.width/2,
                            -watermarkImage.height/2,
                            watermarkImage.width,
                            watermarkImage.height
                        );
                        ctx.restore();
                    }
                    drawImage();
                }
            }
        }
        ctx.globalAlpha = 1;
    }
}

function readPageNumberFilePages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        var page = await doc.getPage(1);
        var canvas = await makeThumbScale(page, 1);
        imageCavas = canvas;
        var vp = page.getViewport({ scale: 1, });
        var html =
                '<div style="height: 100%;"><img src="'+canvas+'" id="pdf-img" style="min-height: '+vp.height+'px; min-width: '+vp.width+'px;"><canvas id="canvas"></canvas></div>';
            data.context = $('<div class="position-relative" style="height: 100%;" id="pdf-page" data-id="1" data-cut="0">')
            .append(html)
            .appendTo($('#file-list'));


        $(".page-range").ionRangeSlider({
            type: "double",
            min: 1,
            max: doc.numPages,
            from: 0,
            to: doc.numPages,
            prefix: "Page: ",
            values_separator: " to "
        });

        $(".page-first").ionRangeSlider({
            min: 1,
            max: doc.numPages,
            from: 1,
            onChange: function (data) {
                DrawPageNumber();
            },
        });
        DrawPageNumber();
    });
}

function addPageNumberFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readPageNumberFilePages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function pageNumberUpload(){
    $('.fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#upload-area').hide();
            $('#preview-area').css('display','inline');
            addPageNumberFile(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage('Max files for add pagenumber is:' + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    addFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
    });
}

function initPageNumber(){
    console.log('initPageNumber jobId: ' + pdfwind.jobId);
    pageNumberUpload();
    $(".font-size").ionRangeSlider({
        min: 10,
        max: 100,
        from: 15,
        onChange: function (data) {
            DrawPageNumber();
        },
    });

    $(".text-opacity").ionRangeSlider({
        type: "single",
        min: 0.00,
        max: 1.00,
        from: 1.00,
        step: 0.01,
        onChange: function (data) {
            DrawPageNumber();
        },
    });

    $(".x-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "X Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawPageNumber();
        },
    });

    $(".y-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "Y Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawPageNumber();
        },
    });

    $('#color-picker').spectrum({
        type: "component",
        preferredFormat: "hex",
        showPalette: true,
        showAlpha: false,
        showInput: true,
        move: function(color) {
            DrawPageNumber();
        },
    });

    $(window).resize(function() {
        if($('#preview-area').is(':visible')){
            DrawPageNumber();
        }
    });

    $('#pagenumber-font').on('change', function(){
        DrawPageNumber();
    });

    $('#pagenumber-type').on('change', function(){
        DrawPageNumber();
    });

    $('input[name="position"]').on('change', function(){
        DrawPageNumber();
    });

    $('#text-italic').on('change', function(){
        DrawPageNumber();
    });

    $('#text-bold').on('change', function(){
        DrawPageNumber();
    });

    $('#first-number').on('change', function(){
        DrawPageNumber();
    });

    $('#addPageNumber').on('click', function(e){
        e.preventDefault();
        var options = $("#pagenumber-action").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        if(pdfwind['color-picker'].length == 0){
            errorMessage('Please select color');
            return false;
        }

        const colorRegxp = /^#([0-9a-f]{3}){1,2}$/i;
        if(!colorRegxp.test(pdfwind['color-picker'])){
            errorMessage('Invalid color');
            return false;
        }

        showWaiting();

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });

    console.log('PageNumber component inited.');
}

function DrawPageNumber(){
    var canvas = document.getElementById('canvas');
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var img = document.getElementById('pdf-img');
    var drawFont = $('#pagenumber-font option:selected').text();
    var pageNumberType = $('#pagenumber-type').val();
    var fontSize = $('.font-size').val();
    var isItalic = $('#text-italic').prop('checked');
    var isBold = $('#text-bold').prop('checked');
    var fontOpcity = $('.text-opacity').val();
    var fontXOffset = $('.x-offset').val();
    var fontYOffset = $('.y-offset').val();
    var firstPage = $('#first-number').val();
    var fontColor = $('#color-picker').spectrum('get').toRgbString();
    var color = fontColor.replace(')', ', ' + fontOpcity + ')').replace('rgb', 'rgba');
    var position = $('input[name="position"]:checked').val();
    canvas.style.position = "absolute";
    canvas.width = img.offsetWidth;
    canvas.height = img.offsetHeight;
    canvas.style.top = img.offsetTop + 'px';
    canvas.style.left = img.offsetLeft + 'px';
    canvas.style.zIndex = '1';
    var italic = isItalic ? 'italic ' : '';
    var bold = isBold ? 'bold ' : '';

    var text = '';
    if(pageNumberType == 1){
        text = firstPage;
    } else if(pageNumberType == 2){
        text = 'Page ' + firstPage;
    } else if(pageNumberType == 3){
        text = 'Page '+firstPage+' of 10';
    } else if(pageNumberType == 4){
        text = '-'+firstPage+'-';
    } else if(pageNumberType == 5){
        text = firstPage+'/10';
    } else if(pageNumberType == 6){
        text = 'Page '+firstPage+'-10';
    } else if(pageNumberType == 7){
        text = firstPage+'-10';
    } else if(pageNumberType == 8){
        text = '('+firstPage+')';
    } else {
        text = firstPage;
    }

    ctx.font = italic + bold + fontSize + 'px ' + drawFont;
    var metrics = ctx.measureText(text);
    var textWidth = parseInt(metrics.width);
    var fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
    var actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
    var textHeight = 0;

    var positions = {
        1: { posx: 10 + (textWidth / 2), posy: 10 + parseInt(actualHeight) / 2 },
        2: { posx: canvas.width / 2, posy: 10 + parseInt(actualHeight) / 2 },
        3: { posx: canvas.width - (textWidth / 2), posy: 10 + parseInt(actualHeight) / 2 },
        4: { posx: 10 + (textWidth / 2), posy: canvas.height / 2 + parseInt(actualHeight) / 2 },
        5: { posx: canvas.width / 2, posy: canvas.height / 2 + parseInt(actualHeight) / 2 },
        6: { posx: canvas.width - (textWidth / 2), posy: canvas.height / 2 + parseInt(actualHeight) / 2 },
        7: { posx: 10 + (textWidth / 2), posy: canvas.height - parseInt(actualHeight) / 2 - 10 },
        8: { posx: canvas.width / 2, posy: canvas.height - parseInt(actualHeight) / 2 - 10 },
        9: { posx: canvas.width - (textWidth / 2), posy: canvas.height - parseInt(actualHeight) / 2 - 10 }
    };

    var pos = positions[position];
    var posx = pos.posx;
    var posy = pos.posy;
    posx += parseInt(fontXOffset);
    posy += parseInt(fontYOffset);
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.translate(posx, posy);
    ctx.fillText(text, 0, 0);
}

function readHeaderFooterFilePages(pdf,data) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({data: pdf}).promise.then(async (doc) => {
        var page = await doc.getPage(1);
        var canvas = await makeThumbScale(page, 1);
        imageCavas = canvas;
        var vp = page.getViewport({ scale: 1, });
        var html =
                '<div style="height: 100%;"><img src="'+canvas+'" id="pdf-img" style="min-height: '+vp.height+'px; min-width: '+vp.width+'px;"><canvas id="canvas"></canvas></div>';
            data.context = $('<div class="position-relative" style="height: 100%;" id="pdf-page" data-id="1" data-cut="0">')
            .append(html)
            .appendTo($('#file-list'));


        $(".header-page-range").ionRangeSlider({
            type: "double",
            min: 1,
            max: doc.numPages,
            from: 0,
            to: doc.numPages,
            prefix: "Page: ",
            values_separator: " to "
        });

        $(".footer-page-range").ionRangeSlider({
            type: "double",
            min: 1,
            max: doc.numPages,
            from: 0,
            to: doc.numPages,
            prefix: "Page: ",
            values_separator: " to "
        });

    });
}

function addHeaderFooterFile(data){
    var file = data.files[0];
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
        readHeaderFooterFilePages(new Uint8Array(e.target.result),data);
    };
    fileReader.readAsArrayBuffer(file);
}

function headerfooterUploadError(){
    $('#textHeaderFooter').hide();
    $('#goBack').show();
}

function headerFooterUpload(){
    $('.fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        singleFileUploads: false,
        dataType: 'json',
        progress: function (e, data) {
            $('#infoStat').html(rp(data));
        },
        done: function (e, data) {
            $('#upload-area').hide();
            $('#preview-area').css('display','inline');
            pdfwind['inited'] = true;
            addHeaderFooterFile(data);
        },
        fail: function(e, data){
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
            $('#uploadError').show();
            $('#infoMsg').text('Error: Upload Failed! Please try again!');
        },
        add: function (e, data){
            if(data.files.length > parseInt(pdfwind.count)){
                errorMessage('Max files for add header and footer is:' + pdfwind.count);
            } else {
                if(cfs(data.files[0].size)){
                    if(testFile(data.files[0]) && testPdf(data.files[0])){
                        var file = data.files[0];
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var array = new Uint8Array(e.target.result);
                            cen(array).then(function(encrypted){
                                if(encrypted){
                                    errorMessage(enced_i18n());
                                    return false;
                                } else {
                                    addFileUpload();
                                    data.process().done(function () {
                                        data.formData = window.pdfwind;
                                        data.submit();
                                    });
                                }
                            });
                        }
                        reader.readAsArrayBuffer(file);
                    } else {
                        ftna();
                    }
                } else {
                    fel();
                }
            }
        },
    });
}

function initHeaderFooter(){
    console.log('initHeaderFooter jobId: ' + pdfwind.jobId);
    headerFooterUpload();
    $(".header-font-size").ionRangeSlider({
        min: 10,
        max: 100,
        from: 15,
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".footer-font-size").ionRangeSlider({
        min: 10,
        max: 100,
        from: 15,
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".header-text-opacity").ionRangeSlider({
        type: "single",
        min: 0.00,
        max: 1.00,
        from: 1.00,
        step: 0.01,
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".footer-text-opacity").ionRangeSlider({
        type: "single",
        min: 0.00,
        max: 1.00,
        from: 1.00,
        step: 0.01,
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".header-text-rotate").ionRangeSlider({
        min: -180,
        max: 180,
        from: 0,
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".footer-text-rotate").ionRangeSlider({
        min: -180,
        max: 180,
        from: 0,
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".header-x-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "X Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".footer-x-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "X Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".header-y-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "Y Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $(".footer-y-offset").ionRangeSlider({
        min: -200,
        max: 200,
        from: 0,
        prefix: "Y Offset:",
        postfix: " PX",
        onChange: function (data) {
            DrawTextHeaderFooter();
        },
    });

    $('#header-color-picker').spectrum({
        type: "component",
        preferredFormat: "hex",
        showPalette: true,
        showAlpha: false,
        showInput: true,
        move: function(color) {
            DrawTextHeaderFooter();
        },
    });

    $('#footer-color-picker').spectrum({
        type: "component",
        preferredFormat: "hex",
        showPalette: true,
        showAlpha: false,
        showInput: true,
        move: function(color) {
            DrawTextHeaderFooter();
        },
    });

    $(window).resize(function() {
        if($('#preview-area').is(':visible')){
            DrawTextHeaderFooter();
        }
    });

    $('#header-font').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#footer-font').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#header-page-type').on('change', function(){
        if($(this).val() == 1){
            $('#header-page-form').hide();
            $('#header-text-form').show();
        } else {
            $('#header-page-form').show();
            $('#header-text-form').hide();
        }
        DrawTextHeaderFooter();
    });

    $('#footer-page-type').on('change', function(){
        if($(this).val() == 1){
            $('#footer-page-form').hide();
            $('#footer-text-form').show();
        } else {
            $('#footer-page-form').show();
            $('#footer-text-form').hide();
        }
        DrawTextHeaderFooter();
    });

    $('#header-pagenumber-type').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#footer-pagenumber-type').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#header-text').on('input', function(){
        DrawTextHeaderFooter();
    });

    $('#footer-text').on('input', function(){
        DrawTextHeaderFooter();
    });

    $('input[name="header-position"]').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('input[name="footer-position"]').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#header-text-italic').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#footer-text-italic').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#header-text-bold').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#footer-text-bold').on('change', function(){
        DrawTextHeaderFooter();
    });

    $('#textHeaderFooter').on('click', function(e){
        e.preventDefault();
        var headerOptions = $("#text-header-action").formToArray();
        $.each(headerOptions, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        if(pdfwind['header-color-picker'].length == 0){
            errorMessage('Please select header color');
            return;
        }

        if(pdfwind['header-page-type'] == 1 && (pdfwind['header-text'].length == 0 || pdfwind['header-text'].length > 100)){
            errorMessage('Header text is 0 or too long');
            return;
        }

        var footerOptions = $("#text-footer-action").formToArray();
        $.each(footerOptions, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        if(pdfwind['footer-color-picker'].length == 0){
            errorMessage('Please select footer color');
            return;
        }

        if(pdfwind['footer-page-type'] == 1 && (pdfwind['footer-text'].length == 0 || pdfwind['footer-text'].length > 100)){
            errorMessage('footer text is 0 or too long');
            return;
        }

        const colorRegxp = /^#([0-9a-f]{3}){1,2}$/i;
        if(!colorRegxp.test(pdfwind['header-color-picker'])){
            errorMessage('Invalid color');
            return;
        }

        if(!colorRegxp.test(pdfwind['footer-color-picker'])){
            errorMessage('Invalid color');
            return;
        }

        showWaiting();

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });

    console.log('HeaderFooter component inited.');
}

function DrawTextHeaderFooter(){
    var headerType = $('#header-page-type option:selected').val();
    var footerType = $('#footer-page-type option:selected').val();

    var headerText = $('#header-text').val();
    var footerText = $('#footer-text').val();

    var headerPageNumberType = $('#header-pagenumber-type').val();
    var footerPageNumberType = $('#footer-pagenumber-type').val();

    var headerDrawFont = $('#header-font option:selected').text();
    var footerDrawFont = $('#footer-font option:selected').text();

    var headerFontSize = $('.header-font-size').val();
    var footerFontSize = $('.footer-font-size').val();

    var isHeaderItalic = $('#header-text-italic').prop('checked');
    var isFooterItalic = $('#footer-text-italic').prop('checked');

    var isHeaderBold = $('#header-text-bold').prop('checked');
    var isFooterBold = $('#footer-text-bold').prop('checked');

    var headerFontOpcity = $('.header-text-opacity').val();
    var footerFontOpcity = $('.footer-text-opacity').val();

    var headerFontRotate = $('.header-text-rotate').val() * Math.PI / 180;
    var footerFontRotate = $('.footer-text-rotate').val() * Math.PI / 180;

    var headerFontXOffset = $('.header-x-offset').val();
    var footerFontXOffset = $('.footer-x-offset').val();

    var headerFontYOffset = $('.header-y-offset').val();
    var footerFontYOffset = $('.footer-y-offset').val();

    var headerFontColor = $('#header-color-picker').spectrum('get').toRgbString();
    var footerFontColor = $('#footer-color-picker').spectrum('get').toRgbString();

    var headerColor = headerFontColor.replace(')', ', ' + headerFontOpcity + ')').replace('rgb', 'rgba');
    var footerColor = footerFontColor.replace(')', ', ' + footerFontOpcity + ')').replace('rgb', 'rgba');

    var headerPosition = $('input[name="header-position"]:checked').val();
    var footerPosition = $('input[name="footer-position"]:checked').val();

    if(headerPosition < 1 || headerPosition > 3){
        return;
    }

    if(footerPosition < 7 || footerPosition > 9){
        return;
    }

    var img = document.getElementById('pdf-img');
    var canvas = document.getElementById('canvas');
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.style.position = "absolute";
    canvas.width = img.offsetWidth;
    canvas.height = img.offsetHeight;
    canvas.style.top = img.offsetTop + 'px';
    canvas.style.left = img.offsetLeft + 'px';
    canvas.style.zIndex = '1';
    var firstPage = '1';
    var headerItalic = isHeaderItalic ? 'italic ' : '';
    var headerBold = isHeaderBold ? 'bold ' : '';

    var footerItalic = isFooterItalic ? 'italic ' : '';
    var footerBold = isFooterBold ? 'bold ' : '';

    ctx.save();
    ctx.font = headerItalic + headerBold + headerFontSize + 'px ' + headerDrawFont;
    var headerDrawText = '1';
    if(headerType == 1){
        headerDrawText = headerText;
    } else {
        if(headerPageNumberType == 1){
            headerDrawText = firstPage;
        } else if(headerPageNumberType == 2){
            headerDrawText = 'Page ' + firstPage;
        } else if(headerPageNumberType == 3){
            headerDrawText = 'Page '+firstPage+' of 10';
        } else if(headerPageNumberType == 4){
            headerDrawText = '-'+firstPage+'-';
        } else if(headerPageNumberType == 5){
            headerDrawText = firstPage+'/10';
        } else if(headerPageNumberType == 6){
            headerDrawText = 'Page '+firstPage+'-10';
        } else if(headerPageNumberType == 7){
            headerDrawText = firstPage+'-10';
        } else if(headerPageNumberType == 8){
            headerDrawText = '('+firstPage+')';
        } else {
            headerDrawText = firstPage;
        }
    }
    var headerMetrics = ctx.measureText(headerDrawText);
    var headerTextWidth = parseInt(headerMetrics.width);
    var headerFontHeight = headerMetrics.fontBoundingBoxAscent + headerMetrics.fontBoundingBoxDescent;
    var headerActualHeight = headerMetrics.actualBoundingBoxAscent + headerMetrics.actualBoundingBoxDescent;
    var headerPositions = {
        1: { posx: 10 + (headerTextWidth / 2), posy: 10 + parseInt(headerActualHeight) / 2 },
        2: { posx: canvas.width / 2, posy: 10 + parseInt(headerActualHeight) / 2 },
        3: { posx: canvas.width - (headerTextWidth / 2) - 10, posy: 10 + parseInt(headerActualHeight) / 2 },
        4: { posx: 10 + (headerTextWidth / 2), posy: canvas.height / 2 + parseInt(headerActualHeight) / 2 },
        5: { posx: canvas.width / 2, posy: canvas.height / 2 + parseInt(headerActualHeight) / 2 },
        6: { posx: canvas.width - (headerTextWidth / 2), posy: canvas.height / 2 + parseInt(headerActualHeight) / 2 },
        7: { posx: 10 + (headerTextWidth / 2), posy: canvas.height - parseInt(headerActualHeight) / 2 - 10 },
        8: { posx: canvas.width / 2, posy: canvas.height - parseInt(headerActualHeight) / 2 - 10 },
        9: { posx: canvas.width - (headerTextWidth / 2) - 10, posy: canvas.height - parseInt(headerActualHeight) / 2 - 10 }
    };

    var headerPos = headerPositions[headerPosition];
    var headerPosx = headerPos.posx;
    var headerPosy = headerPos.posy;
    headerPosx += parseInt(headerFontXOffset);
    headerPosy += parseInt(headerFontYOffset);
    ctx.fillStyle = headerColor;
    ctx.textAlign = 'center';
    ctx.translate(headerPosx, headerPosy);
    ctx.rotate(headerFontRotate);
    ctx.fillText(headerDrawText, 0, 0);
    ctx.restore();

    ctx.save();
    ctx.font = footerItalic + footerBold + footerFontSize + 'px ' + footerDrawFont;
    var footerDrawText = '1';
    if(footerType == 1){
        footerDrawText = footerText;
    } else {
        if(footerPageNumberType == 1){
            footerDrawText = firstPage;
        } else if(footerPageNumberType == 2){
            footerDrawText = 'Page ' + firstPage;
        } else if(footerPageNumberType == 3){
            footerDrawText = 'Page '+firstPage+' of 10';
        } else if(footerPageNumberType == 4){
            footerDrawText = '-'+firstPage+'-';
        } else if(footerPageNumberType == 5){
            footerDrawText = firstPage+'/10';
        } else if(footerPageNumberType == 6){
            footerDrawText = 'Page '+firstPage+'-10';
        } else if(footerPageNumberType == 7){
            footerDrawText = firstPage+'-10';
        } else if(footerPageNumberType == 8){
            footerDrawText = '('+firstPage+')';
        } else {
            footerDrawText = firstPage;
        }
    }
    var footerMetrics = ctx.measureText(footerDrawText);
    var footerTextWidth = parseInt(footerMetrics.width);
    var footerFontHeight = footerMetrics.fontBoundingBoxAscent + footerMetrics.fontBoundingBoxDescent;
    var footerActualHeight = footerMetrics.actualBoundingBoxAscent + footerMetrics.actualBoundingBoxDescent;
    var footerPositions = {
        1: { posx: 10 + (footerTextWidth / 2), posy: 10 + parseInt(footerActualHeight) / 2 },
        2: { posx: canvas.width / 2, posy: 10 + parseInt(footerActualHeight) / 2 },
        3: { posx: canvas.width - (footerTextWidth / 2) - 10, posy: 10 + parseInt(footerActualHeight) / 2 },
        4: { posx: 10 + (footerTextWidth / 2), posy: canvas.height / 2 + parseInt(footerActualHeight) / 2 },
        5: { posx: canvas.width / 2, posy: canvas.height / 2 + parseInt(footerActualHeight) / 2 },
        6: { posx: canvas.width - (footerTextWidth / 2), posy: canvas.height / 2 + parseInt(footerActualHeight) / 2 },
        7: { posx: 10 + (footerTextWidth / 2), posy: canvas.height - parseInt(footerActualHeight) / 2 - 10 },
        8: { posx: canvas.width / 2, posy: canvas.height - parseInt(footerActualHeight) / 2 - 10 },
        9: { posx: canvas.width - (footerTextWidth / 2) - 10, posy: canvas.height - parseInt(footerActualHeight) / 2 - 10 }
    };

    var footerPos = footerPositions[footerPosition];
    var footerPosx = footerPos.posx;
    var footerPosy = footerPos.posy;
    footerPosx += parseInt(footerFontXOffset);
    footerPosy += parseInt(footerFontYOffset);
    ctx.fillStyle = footerColor;
    ctx.textAlign = 'center';
    ctx.translate(footerPosx, footerPosy);
    ctx.rotate(footerFontRotate);
    ctx.fillText(footerDrawText, 0, 0);
    ctx.restore();

}

var pdfData = [];

function tryPassword(pdf, password) {
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({ data: pdf, password: password }).promise.then(async (doc) => {
        showWaiting();
        pdfwind['password'] = password;
        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    }).catch(function(error) {
        if(error.name == 'PasswordException') {
            errorMessage(wps_i18n());
        }
        else {
            errorMessage(error.message);
            $('#goBack').show();
            $('#submitForm').hide();
        }
    });
}

function checkEncrypt(pdf, data){
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({ data: pdf, password: '' }).promise.then(async (doc) => {
        errorMessage('The PDF file is not encrypt!');
        $('#goBack').show();
        $('#submitForm').hide();
    }).catch(function(error) {
        if(error.name == 'PasswordException') {
            $('#goBack').hide();
            showPreview();
            if(getFileNums() > parseInt(pdfwind.count)){
                fep();
                fepa(data);
            } else {
                if(cfs(data.files[0].size)){
                    addFile(data);
                    if(testFile(data.files[0])){
                        data.process().done(function () {
                            data.formData = window.pdfwind;
                            data.submit();
                        });
                    } else {
                        ftna();
                        ftnaa(data);
                    }
                } else {
                    addFile(data);
                    fel();
                    fela(data);
                }
            }
        } else {
            errorMessage(error.message);
            addError(data, error.message);
            $('#goBack').show();
            $('#submitForm').hide();
        }
    });
}

function cen(c){
    return new Promise(function(resolve, reject) {
        var pdfjsLib = window['pdfjs-dist/build/pdf'];
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
        pdfjsLib.getDocument({ data: c, password: ''  }).promise.then(async (doc) => {
            resolve(false);
        }).catch(function(error) {
            if(error.name == 'PasswordException') {
                errorMessage('The file is encrypt!');
                resolve(true);
            } else {
                errorMessage(error.message);
                resolve(true);
            }
        });
    });
}

function initUnlockPdf(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        progress: function (e, data) {
            addProgress(data);
        },
        done: function (e, data) {
            addDone(data);
            $('#submitForm').show();
        },
        fail: function(e, data){
            errorMessage('Upload Failed!');
            addError(data,'Upload Failed!');
            Sentry.captureMessage('Upload Failed');
        },
        add: function (e, data){
            var file = data.files[0];
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                var array = new Uint8Array(e.target.result);
                checkEncrypt(array, data);
                for (var i = 0; i < array.length; i++) {
                    pdfData.push(array[i]);
                }
            };
            fileReader.readAsArrayBuffer(file);
        },
    });

    $('#unlockPdf').on('click', function(e){
        e.preventDefault();
        var password = $("#unlock-password").val();
        if(password.length == 0){
            errorMessage('You must enter the password!');
            return;
        }
        tryPassword(pdfData, password);
    });
}

function checkEncryptForProtect(pdf, data){
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({ data: pdf, password: '' }).promise.then(async (doc) => {
        $('#goBack').hide();
        showPreview();
        if(getFileNums() > parseInt(pdfwind.count)){
            fep();
            fepa(data);
        } else {
            if(cfs(data.files[0].size)){
                addFile(data);
                if(testFile(data.files[0])){
                    data.process().done(function () {
                        data.formData = window.pdfwind;
                        data.submit();
                    });
                } else {
                    ftna();
                    ftnaa(data);
                }
            } else {
                addFile(data);
                fel();
                fela(data);
            }
        }
    }).catch(function(error) {
        if(error.name == 'PasswordException') {
            errorMessage(enced_i18n());
            $('#goBack').show();
            $('#submitForm').hide();
        } else {
            errorMessage(error.message);
            addError(data, error.message);
            $('#goBack').show();
            $('#submitForm').hide();
        }
    });
}

function initProtectPdf(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        progress: function (e, data) {
            addProgress(data);
        },
        done: function (e, data) {
            addDone(data);
            $('#submitForm').show();
        },
        fail: function(e, data){
            addError(data,'Upload Failed!');
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
        },
        add: function (e, data){
            var file = data.files[0];
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                var array = new Uint8Array(e.target.result);
                checkEncryptForProtect(array, data);
                for (var i = 0; i < array.length; i++) {
                    pdfData.push(array[i]);
                }
            };
            fileReader.readAsArrayBuffer(file);
        },
    });

    $('#protectPdf').on('click', function(e){
        e.preventDefault();
        var protectOptions = $("#options").formToArray();
        $.each(protectOptions, function(i, field) {
            pdfwind[field.name] = field.value;
        });
        if(pdfwind['user-password'].length == 0){
            errorMessage('You must enter the user password!');
            return;
        }
        if(pdfwind['owner-password'].length == 0){
            errorMessage('You must enter the user owner password!');
            return;
        }
        showWaiting();
        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}

function readMetaData(pdf, data){
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({ data: pdf, password: '' }).promise.then(async (doc) => {
        doc.getMetadata().then(function(meta) {
            if(meta.info.Title != undefined){
                $('#title').val(meta.info.Title);
            }

            if(meta.info.Author != undefined){
                $('#author').val(meta.info.Author);
            }

            if(meta.info.Subject != undefined){
                $('#subject').val(meta.info.Subject);
            }

            if(meta.info.Keywords != undefined){
                $('#keywords').val(meta.info.Keywords);
            }

            if(meta.info.Creator != undefined){
                $('#creator').val(meta.info.Creator);
            }

            if(meta.info.Producer != undefined){
                $('#producer').val(meta.info.Producer);
            }

            if(meta.info.CreationDate != undefined){
                var cdate = meta.info.CreationDate;
                var year = cdate.substring(2,6);
                var month = cdate.substring(6,8);
                var day = cdate.substring(8,10);
                var hour = cdate.substring(10,12);
                var min = cdate.substring(12,14);
                var sec = cdate.substring(14,16);
                $('#creationdate').val(year+'-'+month+'-'+day+' '+hour+':'+min+':'+sec);
            }

            if(meta.info.ModDate != undefined){
                var year = cdate.substring(2,6);
                var month = cdate.substring(6,8);
                var day = cdate.substring(8,10);
                var hour = cdate.substring(10,12);
                var min = cdate.substring(12,14);
                var sec = cdate.substring(14,16);
                $('#moddate').val(year+'-'+month+'-'+day+' '+hour+':'+min+':'+sec);
            }


        }).catch(function(err) {
            console.log('Error getting meta data');
            console.log(err);
        });
        $('#goBack').hide();
        showPreview();
        if(getFileNums() > parseInt(pdfwind.count)){
            fep();
            fepa(data);
        } else {
            if(cfs(data.files[0].size)){
                addFile(data);
                if(testFile(data.files[0])){
                    data.process().done(function () {
                        data.formData = window.pdfwind;
                        data.submit();
                    });
                } else {
                    ftna();
                    ftnaa(data);
                }
            } else {
                addFile(data);
                fel();
                fela(data);
            }
        }
    }).catch(function(error) {
        if(error.name == 'PasswordException') {
            errorMessage(enced());
            $('#goBack').show();
            $('#submitForm').hide();
        } else {
            errorMessage(error.message);
            addError(data, error.message);
            $('#goBack').show();
            $('#submitForm').hide();
        }
    });
}

function initEditMetaData(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        progress: function (e, data) {
            addProgress(data);
        },
        done: function (e, data) {
            addDone(data);
            $('#submitForm').show();
        },
        fail: function(e, data){
            addError(data,'Upload Failed!');
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
        },
        add: function (e, data){
            var file = data.files[0];
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                var array = new Uint8Array(e.target.result);
                cen(array).then(function(encrypted){
                    if(encrypted){
                        errorMessage(enced_i18n());
                        return false;
                    }
                    else {
                        readMetaData(array, data);
                    }
                });
            };
            fileReader.readAsArrayBuffer(file);
        },
    });

    $('#editMetaData').on('click', function(e){
        e.preventDefault();
        var protectOptions = $("#options").formToArray();
        $.each(protectOptions, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        if(pdfwind['title'].length > 200){
            errorMessage('The title is too long, please shorten it to less than 200 characters');
            return;
        }

        if(pdfwind['author'].length > 200){
            errorMessage('The author is too long, please shorten it to less than 200 characters');
            return;
        }

        if(pdfwind['subject'].length > 200){
            errorMessage('The subject is too long, please shorten it to less than 200 characters');
            return;
        }

        if(pdfwind['keywords'].length > 200){
            errorMessage('The keywords is too long, please shorten it to less than 200 characters');
            return;
        }

        if(pdfwind['creator'].length > 200){
            errorMessage('The creator is too long, please shorten it to less than 200 characters');
            return;
        }

        if(pdfwind['producer'].length > 200){
            errorMessage('The producer is too long, please shorten it to less than 200 characters');
            return;
        }

        if(pdfwind['creationdate'].length > 0 && isNaN(Date.parse(pdfwind['creationdate']))){
            errorMessage('The creation date is invalid, please check it');
            return;
        }

        if(pdfwind['moddate'].length > 0 && isNaN(Date.parse(pdfwind['moddate']))){
            errorMessage('The modification date is invalid, please check it');
            return;
        }

        showWaiting();
        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}

function readRemoveMetaData(pdf, data){
    var pdfjsLib = window['pdfjs-dist/build/pdf'];
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
    pdfjsLib.getDocument({ data: pdf, password: '' }).promise.then(async (doc) => {
        $('#goBack').hide();
        showPreview();
        if(getFileNums() > parseInt(pdfwind.count)){
            fep();
            fepa(data);
        } else {
            if(cfs(data.files[0].size)){
                addFile(data);
                if(testFile(data.files[0])){
                    data.process().done(function () {
                        data.formData = window.pdfwind;
                        data.submit();
                    });
                } else {
                    ftna();
                    ftnaa(data);
                }
            } else {
                addFile(data);
                fel();
                fela(data);
            }
        }
    }).catch(function(error) {
        if(error.name == 'PasswordException') {
            errorMessage(enced_i18n());
            $('#goBack').show();
            $('#submitForm').hide();
        } else {
            errorMessage(error.message);
            addError(data, error.message);
            $('#goBack').show();
            $('#submitForm').hide();
        }
    });
}

function initRemoveMetaData(){
    $('#fileupload').fileupload({
        url: pdfwind.url + '/upload',
        headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
        dropZone: $('#file-zone'),
        limitConcurrentUploads: 1,
        paramName: 'file',
        progress: function (e, data) {
            addProgress(data);
        },
        done: function (e, data) {
            addDone(data);
            $('#submitForm').show();
        },
        fail: function(e, data){
            addError(data,'Upload Failed');
            errorMessage('Error: Upload Failed! Please try again!');
            Sentry.captureMessage('Upload Failed');
        },
        add: function (e, data){
            var file = data.files[0];
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                var array = new Uint8Array(e.target.result);
                cen(array).then(function(encrypted){
                    if(encrypted){
                        errorMessage(enced_i18n());
                        return false;
                    }
                    else {
                        readRemoveMetaData(array, data);
                    }
                });
            };
            fileReader.readAsArrayBuffer(file);
        },
    });

    $('#removeMetaData').on('click', function(e){
        e.preventDefault();

        showWaiting();
        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}


function initCompare(){
    var fileList = [];
    $('.fileupload').each(function () {
        $(this).fileupload({
            url: pdfwind.url + '/upload',
            headers : { 'Content-Payload': pdfwind.payload, 'Content-JobId': pdfwind.jobId, 'Content-Token': pdfwind.token },
            limitConcurrentUploads: 1,
            paramName: 'file',
            singleFileUploads: false,
            dataType: 'json',
            add: function (e, data){
                var el = $(this)[0];
                pdfwind['id'] = el.id;
                $(el).parent().hide();
                if(fileList.includes(el.id)){
                    errorMessage('The file is uploading...Please wait!');
                    return false;
                }
                fileList.push(el.id);
                if(data.files.length > parseInt(pdfwind.count)){
                    errorMessage('Max files for compare is:' + pdfwind.count);
                } else {
                    if(cfs(data.files[0].size)){
                        if(testFile(data.files[0]) && testPdf(data.files[0])){
                            var file = data.files[0];
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                var array = new Uint8Array(e.target.result);
                                cen(array).then(function(encrypted){
                                    if(encrypted){
                                        errorMessage(enced_i18n());
                                        $(el).parent().show();
                                        const index = fileList.indexOf(el.id);
                                        if (index !== -1) {
                                            fileList.splice(index, 1);
                                        }
                                        return false;
                                    } else {
                                        var statbar = $($(this)[0]).parent().parent().find('.drop-title')[0];
                                        $(statbar).html('Uploading...');
                                        data.process().done(function () {
                                            data.formData = window.pdfwind;
                                            data.submit();
                                        });
                                    }
                                });
                            }
                            reader.readAsArrayBuffer(file);
                        } else {
                            ftna();
                        }
                    } else {
                        fel();
                    }
                }
            },
            progress: function (e, data) {
                var statbar = $($(this)[0]).parent().parent().find('.drop-title')[0];
                $(statbar).html(rp(data));
            },
            done: function (e, data) {
                var statbar = $($(this)[0]).parent().parent().find('.drop-title')[0];
                $(statbar).html(data.files[0].name);
                var el = $(this)[0];
                pdfwind[el.id] = data.response().result.data.file_name;
                //if(fileList.includes('first') && fileList.includes('second')){
                if(pdfwind.hasOwnProperty('first') && pdfwind.hasOwnProperty('second')){
                    $('#startCompare').show();
                }
            },
            fail: function(e, data){
                var el = $(this)[0];
                $(el).parent().show();
                const index = fileList.indexOf(el.id);
                if (index !== -1) {
                    fileList.splice(index, 1);
                }
                errorMessage('Error: Upload Failed! Please try again!');
                Sentry.captureMessage('Upload Failed');
                $('#startCompare').hide();
            },
        });
    });

    $(document).bind('drop dragover', function (e) {
        e.preventDefault();
    });

    function showCompareWaiting(){
        $('#drop-area').hide();
        $('#waiting-area').show();
    }

    $('#startCompare').on('click', function(e){
        e.preventDefault();
        if(!pdfwind.hasOwnProperty('first') || !pdfwind.hasOwnProperty('second')){
            errorMessage('Please select two files to compare. Please wait while the file is uploading!');
            return;
        }
        showCompareWaiting();
        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });
    });
}


function isPrivateIP(ip) {
    if(ip == '127.0.0.1' || ip == 'localhost'){
        return true;
    }
    var parts = ip.split('.');
    return parts[0] === '10' ||
        (parts[0] === '172' && (parseInt(parts[1], 10) >= 16 && parseInt(parts[1], 10) <= 31)) ||
        (parts[0] === '192' && parts[1] === '168');
}

function checkValidUrl(input){
    var regex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?$/;
    if(regex.test(input) == false){
        return false;
    }

    var ip = input.split('/')[2].split(':')[0];
    if(isPrivateIP(ip)){
        return false;
    }
    return true;
}

function initWebpage(){
    $("#webpage").on('change keydown paste input', function(){
        if(checkValidUrl(this.value)){
            $('#webpageToPDF').removeClass('disabled');
        } else {
            $('#webpageToPDF').addClass('disabled');
        }
    });

    function showWebpageWaiting(){
        $('#drop-area').hide();
        $('#waiting-area').show();
    }
    $('#webpageToPDF').on('click', function(e){
        e.preventDefault();
        var options = $("#options").formToArray();
        $.each(options, function(i, field) {
            pdfwind[field.name] = field.value;
        });

        showWebpageWaiting();

        $.ajax({
            url: pdfwind.url + '/startJob',
            method: 'post',
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            success: function(result){
                if(result.code == 0){
                    var jobQuery = setInterval(function(){
                        getJob(jobQuery);
                    }, 2000);
                }
            },
            error: function(xhr, textStatus, error){
                $('#waitDiv').show();
                xhrer(xhr);
            }
        });

    });
}

function loadResource(){
    setTimeout(function downloadJs() {
        var element = document.createElement("script");
        element.setAttribute("crossorigin", "anonymous");
        element.async = true;
        element.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8074662674283777";
        document.body.appendChild(element);

        var element2 = document.createElement("script");
        element2.setAttribute("nonce", "n8zMUqel0p6ry94IzcdzFQ");
        element2.async = true;
        element2.src = "https://fundingchoicesmessages.google.com/i/pub-8074662674283777?ers=1";
        document.body.appendChild(element2);


    }, 3000);
}

function loadGTAG(){
    if(window.tagInit){
        return false;
    }

    if(!window.location.href.includes('pdfwind')){
        return false;
    }

    console.log('Tag loaded');
    window.tagInit = true;
    const script = document.createElement('script');
	script.type = 'text/javascript';
    script.setAttribute("data-deferred", "1");
	script.onload = () => {
	  window.dataLayer = window.dataLayer || [];
	  function gtag(){ dataLayer.push(arguments); }
	  gtag('js', new Date());
	  gtag('config', 'G-R2RFLH6RXN');
	}
	script.src = 'https://www.googletagmanager.com/gtag/js?id=G-R2RFLH6RXN';
    script.defer = true;
	document.body.appendChild(script);
}

function loadAds(){
    if(window.adsInit){
        return false;
    }
    if(!window.location.href.includes('pdfwind')){
        return false;
    }
    console.log('Res loaded');
    window.adsInit = true;
    var element = document.createElement("script");
    element.setAttribute("crossorigin", "anonymous");
    element.async = true;
    element.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8074662674283777";
    document.body.appendChild(element);

    /*var element2 = document.createElement("script");
    element2.setAttribute("nonce", "n8zMUqel0p6ry94IzcdzFQ");
    element2.onload = () => {
        (function() {function signalGooglefcPresent() {if (!window.frames['googlefcPresent']) {if (document.body) {const iframe = document.createElement('iframe'); iframe.style = 'width: 0; height: 0; border: none; z-index: -1000; left: -1000px; top: -1000px;'; iframe.style.display = 'none'; iframe.name = 'googlefcPresent'; document.body.appendChild(iframe);} else {setTimeout(signalGooglefcPresent, 0);}}}signalGooglefcPresent();})();
    }
    element2.async = true;
    element2.src = "https://fundingchoicesmessages.google.com/i/pub-8074662674283777?ers=1";
    document.body.appendChild(element2);*/
}

function loadSentry(){
    if(window.sentryInit){
        return false;
    }
    if(!window.location.href.includes('pdfwind')){
        return false;
    }
    console.log('Sentry loaded');
    window.sentryInit = true;
    const script = document.createElement('script');
    script.setAttribute("integrity", "sha384-XrtsNPpOZ+ul39uZL5FBdv8ByR9EAoDxyx2pnT9+txkfvq1oqUSD6jWO+Qjj67LD");
    script.setAttribute("crossorigin", "anonymous");
	script.type = 'text/javascript';
	script.onload = () => {
        Sentry.init({
            dsn: "https://000169c4349c4a808aa2aa5ffa2a9e43@o795307.ingest.sentry.io/4504841241231360",
            integrations: [new Sentry.BrowserTracing()],
            tracesSampleRate: 0.5,
            beforeSend(event, hint) {
                if (event.exception && event.event_id) {
                  Sentry.showReportDialog({ eventId: event.event_id });
                }
                return event;
            },
      });
	}
	script.src = 'https://browser.sentry-cdn.com/7.43.0/bundle.tracing.min.js';
	script.defer = true;
    document.body.appendChild(script);
    window.ybug_settings = {"id":"0maakqf94c6wag2b4sb3"};
    var ybug = document.createElement('script'); ybug.type = 'text/javascript'; ybug.async = true;
    ybug.src = 'https://widget.ybug.io/button/'+window.ybug_settings.id+'.js';
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ybug, s);
}

function initGTAG (event) {
	loadGTAG();
	event.currentTarget.removeEventListener(event.type, initGTAG);
}

function initAds (event) {
	loadAds();
	event.currentTarget.removeEventListener(event.type, initAds);
}

function initSentry (event) {
	loadSentry();
	event.currentTarget.removeEventListener(event.type, initSentry);
}

function LoadRes(){
    /*document.addEventListener('scroll', initGTAG);
    document.addEventListener('mousemove', initGTAG);
    document.addEventListener('touchstart', initGTAG);

    document.addEventListener('scroll', initSentry);
    document.addEventListener('mousemove', initSentry);
    document.addEventListener('touchstart', initSentry);

    document.addEventListener('scroll', initAds);
    document.addEventListener('mousemove', initAds);
    document.addEventListener('touchstart', initAds);*/
    //loadGTAG();
    if (window.matchMedia("(min-width: 767px)").matches){
        loadSentry();
        loadAds();
        //load GTA
    }

    /*setTimeout(loadGTAG, 2000);
    setTimeout(loadSentry, 2000);
    setTimeout(loadAds, 2000);*/
}

function rateFn(){
    $("#rating").rating({showClear: false, showCaption:false}).on("rating:change", function(event, value, caption) {
        $('#rating').rating('refresh', {disabled: true, showClear: false, showCaption: true});
        $.ajax({
            url: 'https://rating.pdfwind.com/rating',
            method: 'post',
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            data: {job: pdfwind['jobId'], star: value},
            success: function(result){
                if(result.code == 1){
                    successMessage('Thanks for rating!');
                } else {
                    errorMessage('You already rated!');
                }
            },
            error: function(xhr, textStatus, error){
                errorMessage(xhr.responseJSON.message);
            }
        });
    });
}

function checkLocale(){
    //get locale
    const getLanguage = () => navigator.userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';

    var lang = '<div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11"><div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-header"><img src="..." class="rounded me-2" alt="..."><strong class="me-auto">Bootstrap</strong><small>11 mins ago</small><button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="toast-body">Hello, world! This is a toast message.</div></div></div>';
    $("body").append(lang);
    var toastLiveExample = document.getElementById('liveToast')
    var toast = new bootstrap.Toast(toastLiveExample)

    toast.show()
    console.log(getLanguage(), $('html')[0].lang);
}
$(function () {
    'use strict';
    console.log("%cWelcome to PDFWind.COM!", "color: blue; font-family: sans-serif; font-size: 2.5em; font-weight: bolder; text-shadow: #000 1px 1px;");
    LoadRes();
    //checkLocale();
	$("#register-form").validate({
		rules: {
			registerUsername: {
				required: true,
				minlength: 4,
				maxlength: 36
			},
			registerEmail: {
				required: true,
				email: 	true
			},
			registerPassword: {
				required: true,
				minlength: 4,
				maxlength: 36
			},
		},

		submitHandler: function(form){
			OnRegisterSubmit(form);
		}
	});

	$("#login-form").validate({
		rules: {
			loginEmail: {
				required: true,
				email: 	true
			},
			loginPassword: {
				required: true,
				minlength: 4,
				maxlength: 36
			},
		},

		submitHandler: function(form){
			OnLoginSubmit(form);
		}
	});

	$("#reset-form").validate({
		rules: {
			Email: {
				required: true,
				email: true
			},
		},

		submitHandler: function(form){
			OnResetSubmit(form);
		}
	});

	$("#reset-password-form").validate({
		rules: {
			email: {
				required: true,
				email: true
			},
			password: {
				required: true,
				minlength: 4,
				maxlength: 36
			},
			password_confirmation: {
				required: true,
				minlength: 4,
				maxlength: 36,
				equalTo: "#password"
			},
		},

		submitHandler: function(form){
			OnResetPasswordSubmit(form);
		}
	});

	$("#change-password-form").validate({
		rules: {
			password: {
				required: true,
				minlength: 4,
				maxlength: 36
			},
			password_confirmation: {
				required: true,
				minlength: 4,
				maxlength: 36,
				equalTo: "#password"
			},
		},

		submitHandler: function(form){
			OnChangePasswordSubmit(form);
		}
	});

	$('#resendSubmit').on('click', function(){
		OnResendEmailSubmit();
	});

	$('#unlink-google').on('click', function(){
		$('.unlink-status').css('display','none');
		$('.unlink-status').html('');

		$.ajax({
			url: '/user/unlink-google',
			method: 'post',
			data: {
			},
			headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
			beforeSend:function(){
			     return confirm("Are you sure?");
			},
			success: function(result){
				printSuccessMsg('.unlink-status', result.message);

			},
			error: function(xhr, textStatus, error){
			    let result = xhr.responseJSON;
			    let errors = result.message;
			    printErrorMsg('.unlink-status', errors);
			}
		});
	});
    if(window.pdfwind){
        rateFn();
        if(pdfwind['type'] == 'wordpdf'
        || pdfwind['type'] == 'excelpdf'
        || pdfwind['type'] == 'pptxpdf'
        || pdfwind['type'] == 'jpgpdf'
        || pdfwind['type'] == 'htmlpdf'
        || pdfwind['type'] == 'mdpdf'
        || pdfwind['type'] == 'txtpdf'
        || pdfwind['type'] == 'wordjpg'
        || pdfwind['type'] == 'epubpdf'){
            initUpload();
        }
        if(pdfwind['type'] == 'pdfword'
        || pdfwind['type'] == 'pdfexcel'
        || pdfwind['type'] == 'pdfpptx'
        || pdfwind['type'] == 'pdfjpg'
        || pdfwind['type'] == 'repairpdf'
        || pdfwind['type'] == 'pdfepub'
        || pdfwind['type'] == 'pdfmobi'
        || pdfwind['type'] == 'pdfpdfa'
        || pdfwind['type'] == 'extractjpg'
        || pdfwind['type'] == 'resizepages'
        || pdfwind['type'] == 'pdftext'
        || pdfwind['type'] == 'flattenpdf'
        || pdfwind['type'] == 'grayscale'
        || pdfwind['type'] == 'compresspdf'){
            initUpload(true);
        }
        if(pdfwind['type'] == 'headerfooter'){
            initHeaderFooter();
        }
        if(pdfwind['type'] == 'pagenumber'){
            initPageNumber();
        }
        if(pdfwind['type'] == 'watermark'){
            initWaterMark();
        }
        if(pdfwind['type'] == 'comparepdf'){
            initCompare();
        }
        if(pdfwind['type'] == 'croppdf'){
            initCropPDF();
        }
        if(pdfwind['type'] == 'deletepages'){
            initDelete();
            $( "#file-list" ).sortable({
                sort: false,
            });
        }
        if(pdfwind['type'] == 'editmeta'){
            initEditMetaData();
        }
        if(pdfwind['type'] == 'extractpages'){
            initExtractPages();
            $( "#file-list" ).sortable({
                sort: false,
            });
        }
        if(pdfwind['type'] == 'mergepdf'){
            initMerge();
            $( "#file-list" ).sortable({
                animation: 150,
            });
        }
        if(pdfwind['type'] == 'sortpdf'){
            initSort();
            $( "#file-list" ).sortable({
                animation: 150,
            });
        }
        if(pdfwind['type'] == 'protectpdf'){
            initProtectPdf();
        }
        if(pdfwind['type'] == 'removemeta'){
            initRemoveMetaData();
        }
        if(pdfwind['type'] == 'rotatepages'){
            initRotate();
            $( "#file-list" ).sortable({
                sort: false,
            });
        }
        if(pdfwind['type'] == 'splitpdf'){
            initSplit();
        }
        if(pdfwind['type'] == 'unlockpdf'){
            initUnlockPdf();
        }
        if(pdfwind['type'] == 'webpagepdf'){
            initWebpage();
        }
    }
	$('#unlink-facebook').on('click', function(){
		$('.unlink-status').css('display','none');
		$('.unlink-status').html('');

		$.ajax({
			url: '/user/unlink-facebook',
			method: 'post',
			data: {
			},
			headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
			beforeSend:function(){
			     return confirm("Are you sure?");
			},
			success: function(result){
				printSuccessMsg('.unlink-status', result.message);

			},
			error: function(xhr, textStatus, error){
			    let result = xhr.responseJSON;
			    let errors = result.message;
			    printErrorMsg('.unlink-status', errors);
			}
		});
	});
	const urlPath = $(location).attr('href');
    if(~urlPath.indexOf('user')){
	  	$('#menuProfile').addClass('active');
    }

    if(~urlPath.indexOf('billing')){
	  	$('#menuBilling').addClass('active');
    }

    if(~urlPath.indexOf('message')){
	  	$('#menuMessage').addClass('active');
    }

	$('#modal-login').on( 'formSubmitSuccess', function(){
	    setTimeout(function(){
	    	window.location = "/user";
	        $('#change-plan').magnificPopup('close');
	    }, 500);
	});

	$('#modal-register').on( 'formSubmitSuccess', function(){
	    setTimeout(function(){
	    	window.location = "/";
	        $('#cancel-plan').magnificPopup('close');
	    }, 500);
	});

	$('#modal-forgot').on( 'formSubmitSuccess', function(){
	    setTimeout(function(){
	        $('#cancel-plan').magnificPopup('close');
	    }, 500);
	});

    $('#googleBtn').on( 'click', function(){
        location.href = "/auth/google";
	});

    $('.facebookBtn').on( 'click', function(){
        location.href = "/auth/facebook";
	});

    $('.startOver').on('click', function(e){
        e.preventDefault();
        location.reload();
    });

    $('#shareOnFacebook').on('click', function(e){
        e.preventDefault();
        var currentURL = encodeURIComponent(window.location.href);
        var shareURL = 'http://www.facebook.com/sharer.php?u=' + currentURL;
        var popUp = window.open(shareURL, 'popupwindow', 'scrollbars=yes,width=600,height=400');
        popUp.focus();
    });

    $('#shareOnTwitter').on('click', function(e){
        e.preventDefault();
        var currentURL = encodeURIComponent(window.location.href);
        var shareURL = 'http://twitter.com/intent/tweet?url='+ currentURL +'&text='+ document.title +'&via=PDFWind&hashtags=PDFWind';
        var popUp = window.open(shareURL, 'popupwindow', 'scrollbars=yes,width=600,height=400');
        popUp.focus();
    });

    $('#deleteJob').on('click', function(e){
        e.preventDefault();
        $.ajax({
            url: pdfwind.url + '/deleteJob',
            method: 'post',
            crossDomain: true,
            contentType: 'application/json',
            data: JSON.stringify(pdfwind),
            headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
            beforeSend:function(){
                    return confirm("Are you sure? Make sure you've downloaded your file before deleting it.");
            },
            success: function(result){
                successMessage(result.message);
            },
            error: function(xhr, textStatus, error){
                let result = xhr.responseJSON;
                let errors = result.message;
                errorMessage(errors);
            }
        });
    });

	$('#startJob').on('click', function(e){
	  e.preventDefault();
	  showWaiting();
	  var options = $("#options").formToArray();
	  $.each(options, function(i, field) {
	  	pdfwind[field.name] = field.value;
	  });

	  $.ajax({
	      url: pdfwind.url + '/startJob',
	      method: 'post',
	      contentType: 'application/json',
	      data: JSON.stringify(pdfwind),
          headers : { 'X-CSRF-TOKEN': $('meta[name="_token').attr('content') },
	      success: function(result){
            if(result.code == 0){
                var jobQuery = setInterval(function(){
                    getJob(jobQuery);
                }, 2000);
            }
	      },
	      error: function(xhr, textStatus, error){
            $('#waitDiv').show();
            xhrer(xhr);
	      }
	  });
	});
    $('.login-popup-link, .register-popup-link, .forgot-popup-link').magnificPopup({
        closeBtnInside:true
    });
});


if (!String.format) {
    String.format = function(format) {
      var args = Array.prototype.slice.call(arguments, 1);
      return format.replace(/{(\d+)}/g, function(match, number) {
        return typeof args[number] != 'undefined'
          ? args[number]
          : match
        ;
      });
    };
}

(function($) {
    $.QueryString = (function(a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i)
        {
            var p=a[i].split('=');
            if (p.length != 2) continue;
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'))
})(jQuery);

(function ($) {
  $.fn.formToArray = function () {
  var data = $(this).serializeArray();
	$("form input:checkbox").each(function () {
        data.push({ name: this.name, value: this.checked });
    });
    return data;
	};
})(jQuery);
